<template>
  <f7-page name="control-cifras-oeb-planificacion-diaria" @page:init="onPageInit" @page:beforeremove="limpiarInterval" @click.native="infoData = null">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Planificaci&oacute;n Diaria</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) cargarInstrucciones()" style="margin-right:4px">
          <span style="background:linear-gradient(135deg,#0F6E56,#27ae80);color:#fff;border-radius:50%;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;font-size:13px;font-weight:700">i</span>
        </f7-link>
        <f7-link @click="generarPDF" :class="{ 'is-disabled': generandoPdf }" style="margin-right:6px" title="Generar informe PDF">
          <span style="background:linear-gradient(135deg,#dc3545,#c82333);color:#fff;border-radius:4px;padding:2px 8px;font-size:10px;font-weight:700;display:inline-flex;align-items:center;gap:3px">{{ generandoPdf ? '…' : 'PDF' }}</span>
        </f7-link>
        <f7-button small fill color="green" @click="guardarConfig" style="margin-right:8px;font-size:10px">Guardar</f7-button>
        <f7-link @click="autoRefresh = !autoRefresh; setupAutoRefresh()" style="margin-right:6px" :title="autoRefresh ? 'Desactivar auto-refresh' : 'Activar auto-refresh (15 min)'">
          <span :style="autoRefresh ? 'background:#198754;color:#fff' : 'background:#f0f2f5;color:#666'" style="border-radius:4px;padding:3px 8px;font-size:10px;font-weight:600">AUTO</span>
        </f7-link>
        <f7-link @click="zoom = Math.max(40, zoom - 10)" style="font-size:12px;min-width:20px">&minus;</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoom = Math.min(150, zoom + 10)" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="cargarDatos" title="Actualizar" style="margin-left:4px"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · El dia se agrega en la propia peticion sobre planificaciones. La cache de -->
    <!-- productividad plan solo se consulta al generar el PDF, no para lo que se pinta aqui. -->
    <!-- Para que "en vivo" sea cierto, cargarDatos se salta ademas la cache de peticiones. -->
    <div class="sello-datos-bar">
      <sello-datos estado="vivo" />
    </div>

    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="pd-layout" :style="{ fontSize: (zoom * 0.12) + 'px' }">

        <!-- SELECTOR FECHA (fijo) -->
        <div class="pd-fecha">
          <f7-link @click="diaPrevio" icon-f7="chevron_left"></f7-link>
          <input type="date" v-model="fechaStr" @change="cargarDatos" style="font-size:14px;font-weight:700;border:1px solid #ddd;border-radius:6px;padding:4px 10px;color:#1a2744">
          <f7-link @click="diaSiguiente" icon-f7="chevron_right"></f7-link>
          <f7-link @click="irAHoy" style="font-size:11px;color:#1a2744;font-weight:600;text-decoration:underline">Hoy</f7-link>
          <span v-if="datos" style="font-size:13px;font-weight:700;color:#1a2744;margin-left:8px">{{ datos.diaSemana }} &middot; S{{ datos.semanaActual }}</span>
        </div>

        <!-- CARGANDO -->
        <div v-if="cargando" style="text-align:center;padding:40px;color:#999;flex-shrink:0">
          <f7-preloader></f7-preloader>
          <p>Cargando datos...</p>
        </div>

        <!-- NO SE HAN PODIDO CARGAR LOS DATOS -->
        <div v-if="errorCarga && !cargando" style="text-align:center;padding:40px;flex-shrink:0">
          <div style="font-weight:700;color:#DC3545;font-size:14px;margin-bottom:6px">No se han podido cargar los datos del d&iacute;a</div>
          <div style="color:#7c8db0;font-size:12px;margin-bottom:12px">{{ errorCarga }}</div>
          <f7-button small fill @click="cargarDatos" style="display:inline-block;min-width:120px">Reintentar</f7-button>
        </div>

        <!-- CARDS PERSONAS (fijo, centrado) -->
        <div v-if="datos && datos.personas && datos.personas.length" class="pd-cards-wrap">
          <div style="display:flex;align-items:center;justify-content:center;gap:8px;padding:2px 0 6px">
            <span style="font-size:12px;font-weight:600;color:#1a2744">Planificadores</span>
            <span v-if="datos && datos.redObjMen" style="background:#E65100;color:#fff;border-radius:3px;padding:1px 5px;font-size:9px;font-weight:700" title="Los objetivos se muestran redistribuidos por d&iacute;as reales, igual que en Productividad Planificaci&oacute;n. Y en un d&iacute;a en que alguien falta, su parte se reparte entre los que s&iacute; trabajan ese d&iacute;a">RED.OBJ.MEN</span>
            <!-- S&aacute;bado o domingo: el 0 de todas las tarjetas tiene que tener su explicaci&oacute;n a la vista. -->
            <span v-if="datos && datos.finDeSemana" style="background:#64748b;color:#fff;border-radius:3px;padding:1px 5px;font-size:9px;font-weight:700" title="Fin de semana: no se trabaja, as&iacute; que el objetivo del d&iacute;a es 0 &euro; para todos. El objetivo del mes se cumple en d&iacute;as laborables">FIN DE SEMANA</span>
            <span v-if="!objetivoFiable" style="background:#DC3545;color:#fff;border-radius:3px;padding:1px 5px;font-size:9px;font-weight:700" title="No se ha podido calcular el objetivo del mes. Lo confirmado hoy es correcto; el Obj/d&iacute;a y el cumplimiento vuelven al recargar en cuanto el c&aacute;lculo funcione.">OBJ. NO DISPONIBLE</span>
            <span class="info-btn" style="background:rgba(0,0,0,0.08);border:1px solid rgba(0,0,0,0.15);color:#1a2744" @click.stop="abrirInfo($event, 'Planificadores', 'El Obj/d\u00eda sale de Productividad Planificaci\u00f3n: es el que se fija all\u00ed en la columna %Obj. Esta pantalla no lo calcula por su cuenta. Es el objetivo de ESTE d\u00eda: el objetivo se cumple en d\u00edas reales de trabajo, as\u00ed que un d\u00eda que alguien no trabaja \u2014vacaciones, baja, fiesta o fin de semana\u2014 su objetivo ese d\u00eda es 0 \u20ac y la tarjeta dice por qu\u00e9. Con RED.OBJ.MEN activado, su parte se reparte entre los que s\u00ed trabajan ese d\u00eda, as\u00ed que el objetivo del equipo para el d\u00eda no baja; el objetivo del mes no cambia, solo c\u00f3mo se reparte entre los d\u00edas. Adem\u00e1s muestra lo confirmado hoy en tiempo real, el porcentaje de cumplimiento, la productividad por hora (Plan/hora = confirmado hoy / horas planificaci\u00f3n) y los d\u00edas reales del mes. Colores seg\u00fan cumplimiento: cyan (>100%), verde (98-100%), amarillo (94-97%), rojo (<94%). Bot\u00f3n \u00d7 para ocultar, bot\u00f3n + para agregar: la lista de planificadores es tuya y solo cambia lo que ves t\u00fa, pero es la misma que ves en Productividad Planificaci\u00f3n y te sigue desde cualquier equipo. Se auto-actualiza cada 15 minutos.')">i</span>
          </div>
          <div class="pd-cards">
            <div v-for="p in personasFiltradas" :key="p.codigo" class="persona-card" :style="'border-left:4px solid ' + (!objetivoFiable || p.ausenciaHoy ? '#bbb' : p.pctCumplimiento > 100 ? '#17A2B8' : p.pctCumplimiento >= 98 ? '#28A745' : p.pctCumplimiento >= 94 ? '#FFC107' : '#DC3545')">
              <span @click.stop="ocultarPersona(p.codigo)" class="card-hide-btn" title="Ocultar en tu vista. Los dem&aacute;s usuarios lo siguen viendo">&#10005;</span>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">
                <strong style="font-size:22px;color:#1a2744;letter-spacing:-0.5px">{{ p.codigo }}</strong>
                <span v-if="p.ausenciaHoy" class="badge-pct-card" style="background:#E0F7FA;color:#006064" :title="explicacionAusencia(p.ausenciaHoy) + '. Su Obj/día de un día normal es ' + fmtNum(p.objDiaMes) + ' €.'">{{ textoAusencia(p.ausenciaHoy) }}</span>
                <span v-else class="badge-pct-card" :class="objetivoFiable ? pctClase(p.pctCumplimiento) : ''">{{ objetivoFiable ? p.pctCumplimiento + '%' : 'n/d' }}</span>
              </div>
              <div style="font-size:12px;color:#7c8db0;margin-bottom:8px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:200px">{{ p.nombre }}</div>
              <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px">
                <div><span class="card-lbl">Obj/d&iacute;a</span><div class="card-val" :title="p.ausenciaHoy ? explicacionAusencia(p.ausenciaHoy) : ''">{{ objetivoFiable ? fmtNum(p.objDia) : 'n/d' }}</div></div>
                <div><span class="card-lbl">Confirmado hoy</span><div class="card-val" style="color:#198754;font-size:28px">{{ fmtNum(p.planificadoHoy) }}</div></div>
                <div><span class="card-lbl">D.R</span><div class="card-val" style="font-size:18px">{{ p.dr }}</div></div>
                <div><span class="card-lbl">Obj/hora</span><div class="card-val" style="font-size:16px;color:#2d5f8a">{{ objetivoFiable ? fmtNum(getObjHora(p)) : 'n/d' }}</div></div>
                <div><span class="card-lbl">Plan/hora</span><div class="card-val" style="font-size:16px">{{ fmtNum(p.planPorHora) }}</div></div>
                <div v-if="p.ppendHoy > 0" style="display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end" title="Planificado hoy pendiente de confirmar (l&iacute;nea PPEND). No suma al Confirmado hoy.">
                  <span class="card-lbl" style="color:#856404">OEB PPEND</span>
                  <div style="background:#FFF3CD;color:#856404;border:1px solid #FFEEBA;border-radius:4px;padding:1px 6px;font-size:14px;font-weight:700">{{ fmtNum(p.ppendHoy) }}</div>
                </div>
                <div v-else></div>
              </div>
            </div>
            <!-- Ocultar y agregar son la vista de cada uno: los tiene todo el que entra en la
                 pantalla, igual que antes de que la lista viviera en el servidor. -->
            <div class="card-add" @click="mostrarPopupAgregar = true">
              <div style="font-size:28px;color:#bbb">+</div>
              <div style="font-size:10px;color:#bbb">Agregar</div>
            </div>
          </div>
          <span v-if="numOcultas > 0" style="font-size:10px;color:#dc3545;text-align:center;display:block;margin-top:2px">({{ numOcultas }} ocultas)</span>
        </div>

        <!-- TIMELINE POR HORA (scrollable) -->
        <div v-if="personasFiltradas.length" class="pd-timeline-wrap">
          <div class="pd-timeline-hdr">
            <span>Timeline &mdash; {{ fechaDisplay }} <span class="info-btn" style="margin-left:6px;border-color:rgba(255,255,255,0.4)" @click.stop="abrirInfo($event, 'Timeline de planificaci\u00f3n', 'Muestra por hora lo que cada planificador ha confirmado hoy (la hora es la de confirmaci\u00f3n de la planificaci\u00f3n). Cada celda muestra el total de esa hora. Click en celda para ver detalle: l\u00edneas de pedido, materia, servicio, cliente, SAP y enlace al pedido. Colores seg\u00fan cumplimiento acumulado vs objetivo proporcional: rojo (<94%), amarillo (94-97%), verde (98-100%), cyan (>100%). Hora actual marcada con AHORA. Horas futuras en gris. Auto-scroll al centro de la hora actual.')">i</span></span>
            <span style="font-size:10px;opacity:0.7">{{ datos.totalDocs }} registros</span>
          </div>
          <div class="timeline-scroll" ref="timelineScroll">
            <table class="tbl-timeline">
              <thead>
                <tr>
                  <th class="col-hora-hdr">Hora</th>
                  <th v-for="p in personasFiltradas" :key="'th-'+p.codigo" class="col-persona-hdr">{{ p.codigo }}</th>
                  <th class="col-total-hdr">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(h, hIdx) in horasVisibles" :key="'hr-'+h" :class="{'hora-actual': esHoraActual(h), 'hora-par': hIdx % 2 === 0, 'hora-futura': esHoraFutura(h)}">
                  <td class="col-hora">
                    <span style="font-size:14px;font-weight:700">{{ h }}:00</span>
                    <span v-if="esHoraActual(h)" style="display:block;font-size:8px;color:#185FA5;font-weight:700">AHORA &rarr;</span>
                  </td>
                  <td v-for="p in personasFiltradas" :key="'hc-'+p.codigo+'-'+h" class="col-celda" @click="abrirDetalleHora(p, h)">
                    <template v-if="getTotalHoraPersona(p, h) > 0">
                      <div style="display:flex;align-items:center;justify-content:center;gap:6px">
                        <span :style="'width:10px;height:10px;border-radius:50%;flex-shrink:0;background:' + getColorCeldaHora(p, h)"></span>
                        <span class="celda-num">{{ fmtNum(getTotalHoraPersona(p, h)) }}</span>
                      </div>
                      <span class="celda-count">{{ getCountHoraPersona(p, h) }}</span>
                    </template>
                    <template v-else><span style="color:#ddd;font-size:14px">&mdash;</span></template>
                  </td>
                  <td class="col-total-hora">{{ getTotalHora(h) > 0 ? fmtNum(getTotalHora(h)) : '' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="fila-total">
                  <td class="col-hora" style="font-weight:700">TOTAL</td>
                  <td v-for="p in personasFiltradas" :key="'tt-'+p.codigo" style="text-align:center;padding:8px;vertical-align:middle">
                    <div style="display:flex;align-items:center;justify-content:center;gap:6px">
                      <span :style="'width:12px;height:12px;border-radius:50%;flex-shrink:0;background:' + getColorCumplDia(p)"></span>
                      <span style="font-size:15px;font-weight:700">{{ fmtNum(p.planificadoHoy) }}</span>
                    </div>
                    <div style="font-size:10px;font-weight:600;margin-top:2px" :style="'color:' + getColorCumplDia(p)">{{ txtPctCumplDia(p) }}</div>
                  </td>
                  <td class="col-total-hora" style="font-weight:800;font-size:15px;vertical-align:middle">
                    <div style="display:flex;align-items:center;justify-content:center;gap:6px">
                      <span :style="'width:12px;height:12px;border-radius:50%;flex-shrink:0;background:' + getColorCumplTotal()"></span>
                      <span>{{ fmtNum(getTotalGeneral()) }}</span>
                    </div>
                    <div style="font-size:10px;font-weight:600;margin-top:2px" :style="'color:' + getColorCumplTotal()">{{ objetivoFiable ? getPctCumplTotal() + '%' : 'n/d' }}</div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div style="padding:4px 14px;display:flex;gap:12px;font-size:10px;background:#fafbfc;border-top:1px solid #e5e7eb;flex-wrap:wrap;flex-shrink:0">
            <span><span class="celda-excellent" style="padding:1px 6px;border-radius:2px;font-size:9px">&gt;100%</span></span>
            <span><span class="celda-good" style="padding:1px 6px;border-radius:2px;font-size:9px">98-100%</span></span>
            <span><span class="celda-warning" style="padding:1px 6px;border-radius:2px;font-size:9px">94-97%</span></span>
            <span><span class="celda-critical" style="padding:1px 6px;border-radius:2px;font-size:9px">&lt;94%</span></span>
          </div>
        </div>

        <!-- CONTROL SEMANAL -->
        <div v-if="personasFiltradas.length && datos && datos.semanasVisibles" class="pd-semanal-wrap">
          <div style="background:#1a2744;color:white;padding:6px 14px;font-size:11px;font-weight:600">
            Control semanal &mdash; Destino de lo confirmado hoy <span class="info-btn" style="margin-left:6px;border-color:rgba(255,255,255,0.4)" @click.stop="abrirInfo($event, 'Control semanal', 'Muestra PARA QU\u00c9 semanas es lo confirmado HOY. Cada celda = importe total confirmado hoy con fecha de ejecuci\u00f3n en esa semana. Permite ver si se planifica para la semana actual, la siguiente o m\u00e1s adelante. Semana actual resaltada en azul. Fila TOTAL suma todos los planificadores.')">i</span>
          </div>
          <div style="overflow-x:auto;max-height:200px;overflow-y:auto">
            <table style="border-collapse:collapse;font-size:11px;width:100%;min-width:500px">
              <thead>
                <tr style="background:#f0f4fa">
                  <th style="padding:5px 10px;text-align:left;min-width:55px;position:sticky;left:0;background:#f0f4fa;z-index:2;font-weight:700;font-size:12px">C&Oacute;D</th>
                  <th v-for="sem in datos.semanasVisibles" :key="'sh-'+sem.semana" style="padding:4px 6px;text-align:center;min-width:72px;font-weight:700;font-size:12px" :class="{'sem-actual': sem.semana === datos.semanaActual}">
                    S{{ sem.semana }}<br><span style="font-size:8px;color:#7c8db0;font-weight:400">{{ sem.inicio }}</span>
                  </th>
                  <th style="padding:5px 8px;text-align:right;min-width:65px;background:#e8ecf1;font-weight:700;font-size:12px">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, idx) in personasFiltradas" :key="'sr-'+p.codigo" :class="idx % 2 === 1 ? 'fila-alt' : ''">
                  <!-- Mismo rol que la × de las tarjetas: este punto guarda la MISMA lista
                       compartida, así que dejarlo visible a PLANIFICACION solo servía para que la
                       persona desapareciera y el guardado devolviera un error. -->
                  <td style="padding:4px 10px;font-weight:700;font-size:13px;position:sticky;left:0;background:inherit;z-index:1"><span @click.stop="ocultarPersona(p.codigo)" style="cursor:pointer;color:#dc3545;font-size:8px;margin-right:3px;opacity:0.5" title="Ocultar en tu vista. Los dem&aacute;s usuarios lo siguen viendo">&#9679;</span>{{ p.codigo }}</td>
                  <td v-for="sem in datos.semanasVisibles" :key="'sc-'+p.codigo+'-'+sem.semana" style="padding:4px 6px;text-align:center;border-right:1px solid #f0f0f0;font-size:13px" :class="{'sem-actual': sem.semana === datos.semanaActual}">
                    <template v-if="p.porSemanaDestino && p.porSemanaDestino[String(sem.semana)]">
                      <strong>{{ fmtNum(p.porSemanaDestino[String(sem.semana)]) }}</strong>
                    </template>
                    <template v-else><span style="color:#e0e0e0">&mdash;</span></template>
                  </td>
                  <td style="padding:4px 8px;text-align:right;font-weight:700;background:#f5f7fa;font-size:13px">{{ fmtNum(p.planificadoHoy) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="background:#eef1f7;font-weight:700">
                  <td style="padding:5px 10px;position:sticky;left:0;background:#eef1f7;z-index:1;font-size:12px">TOTAL</td>
                  <td v-for="sem in datos.semanasVisibles" :key="'st-'+sem.semana" style="padding:5px 6px;text-align:center;font-size:13px" :class="{'sem-actual': sem.semana === datos.semanaActual}">
                    <strong>{{ fmtNum(getTotalSemana(sem.semana)) }}</strong>
                  </td>
                  <td style="padding:5px 8px;text-align:right;background:#e8ecf1;font-size:13px">{{ fmtNum(getTotalGeneral()) }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <!-- POPUP DETALLE HORA -->
        <div v-if="detalleHoraItems" class="guia-overlay" @click="detalleHoraItems = null">
          <div class="guia-popup" @click.stop style="width:700px;max-height:500px">
            <div class="guia-hdr">
              <div>
                <div style="font-size:14px;font-weight:700;color:#fff">{{ detalleHoraPersona }}</div>
                <div style="font-size:11px;color:rgba(255,255,255,.6)">{{ detalleHoraItems.length }} registros &middot; Total: {{ fmtNum(detalleHoraTotal) }} &euro;</div>
              </div>
              <span @click="detalleHoraItems = null" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
            </div>
            <div style="flex:1;overflow-y:auto;padding:8px 12px">
              <table style="width:100%;border-collapse:collapse;font-size:12px">
                <thead>
                  <tr style="background:#f0f4fa">
                    <th style="padding:6px 8px;text-align:left">Hora</th>
                    <th style="padding:6px 8px;text-align:right">Importe</th>
                    <th style="padding:6px 8px;text-align:left">Materia</th>
                    <th style="padding:6px 8px;text-align:left">Servicio</th>
                    <th style="padding:6px 8px;text-align:left">Cliente</th>
                    <th style="padding:6px 8px;text-align:left">Fecha dest.</th>
                    <th style="padding:6px 8px;text-align:left">SAP</th>
                    <th style="padding:6px 8px;text-align:center">TPC</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in detalleHoraItems" :key="'di-'+idx" style="border-bottom:1px solid #f0f0f0">
                    <td style="padding:5px 8px;font-weight:600">{{ item.hora }}</td>
                    <td style="padding:5px 8px;text-align:right;font-weight:700;color:#1a2744;font-size:13px">{{ fmtNum(item.importe) }}</td>
                    <td style="padding:5px 8px"><span style="background:#E3F2FD;color:#185FA5;padding:2px 6px;border-radius:3px;font-size:10px;font-weight:600">{{ item.materia }}</span></td>
                    <td style="padding:5px 8px;font-size:11px;max-width:160px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ item.servicio }}</td>
                    <td style="padding:5px 8px;font-size:11px;max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ item.cliente }}</td>
                    <td style="padding:5px 8px;font-size:11px">{{ item.fechaPlanificado || ('S' + item.semanaDestino) }}</td>
                    <td style="padding:5px 8px;font-size:11px"><a v-if="item.pedidoId" href="#" @click.prevent.stop="navegarPedido(item.pedidoId)" style="color:#0d6efd;text-decoration:underline;cursor:pointer">{{ item.numeroPedidoSap || 'Ver' }}</a><span v-else style="color:#888">{{ item.numeroPedidoSap || '\u2014' }}</span></td>
                    <td style="padding:5px 8px;text-align:center"><span v-if="item.tpc === 'S'" style="color:#198754;font-weight:700">&#10003;</span><span v-else style="color:#ccc">&mdash;</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- POPUP GU\u00cdA DE USO -->
        <div v-if="popupInfo" class="guia-overlay" @click="popupInfo = false">
          <div class="guia-popup" @click.stop style="width:650px;max-height:85vh">
            <div class="guia-hdr">
              <div style="display:flex;align-items:center;gap:10px">
                <span style="font-size:24px">&#128202;</span>
                <div><div style="font-size:16px;font-weight:800;color:#fff">Gu&iacute;a de uso</div><div style="font-size:10px;color:rgba(255,255,255,.6)">PLANIFICACI&Oacute;N DIARIA</div></div>
              </div>
              <div style="display:flex;align-items:center;gap:6px">
                <span style="background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff">{{ instrucciones.length }}</span>
                <span @click="modoEdicion = !modoEdicion" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:13px;cursor:pointer;display:flex;align-items:center;justify-content:center" :style="modoEdicion ? 'background:rgba(255,255,255,.3)' : ''" title="Editar">&#9998;</span>
                <span @click="popupInfo = false" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
              </div>
            </div>
            <div style="padding:8px 16px;flex-shrink:0">
              <div style="position:relative;display:flex;align-items:center">
                <span style="position:absolute;left:10px;font-size:13px;color:#94a3b8">&#128269;</span>
                <input v-model="buscarInstr" placeholder="Buscar..." style="width:100%;padding:8px 8px 8px 32px;border:1px solid #e2e8f0;border-radius:8px;font-size:13px;outline:none">
                <span v-if="buscarInstr" @click="buscarInstr = ''" style="position:absolute;right:8px;cursor:pointer;color:#94a3b8;font-size:14px">&times;</span>
              </div>
            </div>
            <div style="flex:1;overflow-y:auto;padding:0 16px 16px;background:linear-gradient(180deg,#f8fafc,#f0f2f5)">
              <div v-for="(inst, idx) in instFiltradas" :key="inst.id || idx" style="background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid #1a2744;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.04)">
                <div @click="expandedInst = expandedInst === idx ? null : idx" style="display:flex;gap:10px;padding:10px;cursor:pointer;align-items:center">
                  <span style="min-width:26px;height:26px;background:#1a2744;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800">{{ inst.orden != null ? inst.orden + 1 : idx + 1 }}</span>
                  <span style="flex:1;font-size:13px;font-weight:600;color:#1e293b">{{ inst.titulo }}</span>
                  <span v-if="modoEdicion" @click.stop="moverInstruccion(inst, -1)" style="cursor:pointer;font-size:11px;color:#94a3b8;padding:2px 4px" title="Subir">&#9650;</span>
                  <span v-if="modoEdicion" @click.stop="moverInstruccion(inst, 1)" style="cursor:pointer;font-size:11px;color:#94a3b8;padding:2px 4px" title="Bajar">&#9660;</span>
                  <span v-if="modoEdicion" @click.stop="eliminarInstruccion(inst)" style="cursor:pointer;font-size:12px;color:#dc3545;padding:2px 4px" title="Eliminar">&#10005;</span>
                  <span style="font-size:10px;color:#94a3b8">{{ expandedInst === idx ? '&#9650;' : '&#9660;' }}</span>
                </div>
                <div v-if="expandedInst === idx" style="padding:0 12px 12px;border-top:1px solid #f1f5f9">
                  <template v-if="modoEdicion">
                    <input v-model="inst.titulo" style="width:100%;padding:6px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;font-weight:600;margin-top:8px;outline:none" placeholder="T&iacute;tulo">
                    <textarea v-model="inst.texto" rows="4" style="width:100%;padding:6px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;margin-top:6px;outline:none;resize:vertical" placeholder="Contenido"></textarea>
                    <div style="margin-top:6px;text-align:right">
                      <span @click="guardarInstruccion(inst)" style="background:#198754;color:#fff;padding:4px 12px;border-radius:4px;font-size:11px;cursor:pointer;font-weight:600">Guardar</span>
                    </div>
                  </template>
                  <template v-else>
                    <div style="font-size:12.5px;line-height:1.6;color:#334155;padding-top:8px">{{ inst.texto }}</div>
                  </template>
                </div>
              </div>
              <div v-if="modoEdicion" style="text-align:center;padding:8px">
                <span @click="nuevaInstruccion" style="background:#1a2744;color:#fff;padding:6px 16px;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600">+ Nuevo apartado</span>
              </div>
              <div v-if="!instFiltradas.length" style="text-align:center;padding:40px;font-size:12px;color:#94a3b8">Sin resultados</div>
            </div>
          </div>
        </div>

        <!-- POPUP AGREGAR PERSONA -->
        <div v-if="mostrarPopupAgregar" class="guia-overlay" @click="mostrarPopupAgregar = false">
          <div class="guia-popup" @click.stop style="width:340px;max-height:450px">
            <div class="guia-hdr">
              <div style="font-size:14px;font-weight:700;color:#fff">Agregar persona</div>
              <span @click="mostrarPopupAgregar = false" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
            </div>
            <div style="flex:1;overflow-y:auto;padding:12px 16px">
              <div v-if="personasOcultasLista.length === 0" style="color:#999;font-size:12px;padding:20px 0;text-align:center">No hay personas ocultas</div>
              <div v-for="p in personasOcultasLista" :key="'add-'+p.codigo" style="display:flex;justify-content:space-between;align-items:center;padding:8px;border-bottom:1px solid #f0f0f0;cursor:pointer" @click="mostrarPersona(p.codigo); mostrarPopupAgregar = false">
                <div><div style="font-weight:600;font-size:13px">{{ p.codigo }}</div><div style="font-size:11px;color:#888">{{ p.nombre }}</div></div>
                <span style="color:#198754;font-size:18px;font-weight:700">+</span>
              </div>
              <div style="margin-top:12px;text-align:center">
                <span @click="mostrarTodas(); mostrarPopupAgregar = false" style="background:#1a2744;color:white;padding:6px 16px;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600">Mostrar todos</span>
              </div>
            </div>
          </div>
        </div>

        <!-- TOOLTIP INFO -->
        <div v-if="infoData" style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:250;background:transparent" @click="infoData = null">
          <div :style="infoPos" style="background:#1a2744;color:#fff;padding:10px 14px;border-radius:8px;font-size:12px;line-height:1.5;max-width:320px;min-width:200px;box-shadow:0 4px 16px rgba(0,0,0,0.25);font-weight:400" @click.stop>
            <div style="font-weight:600;margin-bottom:4px">{{ infoData.nombre }}</div>
            {{ infoData.desc }}
          </div>
        </div>

        <!-- SIN DATOS -->
        <div v-if="datos && (!datos.personas || !datos.personas.length) && !cargando" style="text-align:center;padding:40px;color:#999;font-size:13px;flex-shrink:0">
          No hay planificaciones para este d&iacute;a.
        </div>

        <!-- INFO -->
        <div v-if="datos" style="padding:4px 16px 8px;font-size:11px;color:#999;flex-shrink:0">
          {{ fechaDisplay }} &middot; {{ datos.totalDocs }} registros &middot; {{ personasFiltradas.length }} planificadores
        </div>
      </div>
    </f7-page-content>
  </f7-page>
</template>

<style scoped>
/* Layout */
.pd-layout { display:flex; flex-direction:column; height:calc(100vh - 44px); overflow:hidden; padding:0 12px; }
.pd-fecha { display:flex; align-items:center; justify-content:center; gap:10px; padding:8px 0; flex-shrink:0; }
.pd-cards-wrap { flex-shrink:0; padding:4px 0 10px; }
.pd-cards { display:flex; gap:16px; justify-content:center; flex-wrap:wrap; }
.pd-timeline-wrap { flex:1; overflow:hidden; border-radius:8px; border:1px solid #dbe1ec; display:flex; flex-direction:column; margin-bottom:8px; }
.pd-timeline-hdr { background:#1a2744; color:white; padding:8px 14px; font-size:12px; font-weight:600; display:flex; justify-content:space-between; align-items:center; flex-shrink:0; }
.timeline-scroll { flex:1; overflow-y:auto; overflow-x:auto; }
.pd-semanal-wrap { flex-shrink:0; border-radius:8px; border:1px solid #dbe1ec; overflow:hidden; margin-bottom:8px; }

/* Cards personas */
.persona-card { background:#fff; border:1px solid #e0e0e0; border-radius:12px; padding:16px 20px; min-width:280px; max-width:320px; box-shadow:0 2px 8px rgba(0,0,0,0.08); flex-shrink:0; position:relative; }
.card-hide-btn { position:absolute; top:6px; right:8px; width:16px; height:16px; border-radius:50%; background:rgba(220,53,69,0.1); color:#dc3545; font-size:9px; cursor:pointer; display:flex; align-items:center; justify-content:center; opacity:0.4; transition:opacity 0.15s; }
.card-hide-btn:hover { opacity:1; background:rgba(220,53,69,0.2); }
.card-add { min-width:100px; display:flex; flex-direction:column; align-items:center; justify-content:center; border:2px dashed #ddd; border-radius:12px; padding:16px; cursor:pointer; flex-shrink:0; transition:border-color 0.15s; }
.card-add:hover { border-color:#999; }
.card-lbl { font-size:10px; color:#7c8db0; }
.card-val { font-size:20px; font-weight:700; color:#1a2744; line-height:1.2; }
.badge-pct-card { display:inline-block; padding:4px 12px; border-radius:2em; font-size:14px; font-weight:700; }
.badge-pct-card.pct-excellent { background:#E0F7FA; color:#006064; }
.badge-pct-card.pct-good { background:#E8F5E9; color:#1B5E20; }
.badge-pct-card.pct-warning { background:#FFF9E6; color:#856404; }
.badge-pct-card.pct-critical { background:#FDEDEE; color:#991B1B; }

/* Timeline tabla */
.tbl-timeline { border-collapse:collapse; width:100%; min-width:600px; }
.tbl-timeline thead tr { background:#1a2744; }
.col-hora-hdr { padding:8px 12px; text-align:left; min-width:70px; position:sticky; left:0; z-index:3; background:#1a2744; color:white; font-size:13px; font-weight:700; }
.col-persona-hdr { padding:8px 10px; text-align:center; min-width:110px; color:white; font-size:15px; font-weight:700; }
.col-total-hdr { padding:8px 10px; text-align:center; min-width:70px; color:white; font-size:13px; font-weight:700; background:#0f1b30; }
.tbl-timeline tbody tr { border-bottom:1px solid #e8ecf0; min-height:48px; }
.col-hora { padding:8px 12px; font-weight:700; font-size:14px; color:#1a2744; position:sticky; left:0; z-index:1; background:white; min-width:70px; }
.col-celda { padding:8px 10px; text-align:center; border-right:1px solid #f0f0f0; cursor:pointer; vertical-align:middle; transition:background 0.1s; min-height:48px; }
.col-celda:hover { background:#f0f4fa !important; }
.col-total-hora { padding:8px 10px; text-align:center; font-weight:700; font-size:13px; color:#1a2744; background:#f8f9fb; }
.celda-num { font-size:16px; font-weight:700; display:block; line-height:1.2; }
.celda-count { font-size:9px; color:#94a3b8; }
.fila-total td { background:#eef1f7; border-top:2px solid #c8d0de; }

/* Hora estados */
.hora-par td { background:#fafbfc; } .hora-par .col-hora { background:#fafbfc; }
.hora-actual td { background:#E3F2FD !important; } .hora-actual .col-hora { background:#E3F2FD !important; border-left:4px solid #185FA5; }
.hora-futura td { opacity:0.45; } .hora-futura:hover td { opacity:1; }

/* Colores cumplimiento */
.celda-critical { background:#FDEDEE !important; color:#991B1B !important; }
.celda-warning { background:#FFF9E6 !important; color:#856404 !important; }
.celda-good { background:#E8F5E9 !important; color:#1B5E20 !important; }
.celda-excellent { background:#E0F7FA !important; color:#006064 !important; }

/* Semanal */
.sem-actual { background:#E3F2FD !important; font-weight:700; }
.fila-alt td { background:#f8f9fb; }

/* Popups */
.guia-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:200; background:rgba(0,0,0,0.4); }
.guia-popup { position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); z-index:201; background:#fff; border-radius:12px; box-shadow:0 8px 30px rgba(0,0,0,0.25); display:flex; flex-direction:column; overflow:hidden; }
.guia-hdr { background:linear-gradient(135deg,#1a2744,#2d5f8a); padding:12px 16px; display:flex; justify-content:space-between; align-items:center; }
.info-btn { display:inline-flex; align-items:center; justify-content:center; width:16px; height:16px; border-radius:50%; background:rgba(255,255,255,0.3); border:1px solid rgba(255,255,255,0.4); font-size:9px; font-weight:700; cursor:pointer; color:inherit; flex-shrink:0; vertical-align:middle; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; display: flex; flex-wrap: wrap; gap: 8px; }
</style>

<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import SelloDatos from '../../components/SelloDatos.vue';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';
import { atarALaSesion } from '../../js/utils/sesionDePeticiones.js';

/**
 * Tope de espera de una carga. Las peticiones no tienen límite de tiempo y hay respuestas que no
 * llegan a resolver ni a rechazar la promesa (un 401 cierra la sesión sin hacer ninguna de las dos,
 * ver el errorCallback de DatabaseModel.sendRequest), así que sin este tope la pantalla se puede
 * quedar en "Cargando datos..." para siempre y sin decir nada.
 */
var ESPERA_MAXIMA_MS = 45000;

export default {
  components: { SelloDatos },
  data: function() {
    return {
      fechaStr: new Date().toISOString().substring(0, 10),
      datos: null,
      cargando: false,
      errorCarga: null,
      autoRefresh: true,
      refreshTimer: null,
      zoom: 100,
      personasOcultas: {},
      mostrarPopupAgregar: false,
      popupInfo: false,
      instrucciones: [],
      buscarInstr: '',
      expandedInst: null,
      modoEdicion: false,
      detalleHoraItems: null,
      detalleHoraPersona: '',
      detalleHoraTotal: 0,
      infoData: null,
      infoPos: {},
      generandoPdf: false,
      logoBase64Cache: null,
      prodPlanCache: {}
    };
  },
  computed: {
    fechaDisplay: function() {
      var parts = this.fechaStr.split('-');
      if (parts.length !== 3) return this.fechaStr;
      var meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      return parseInt(parts[2]) + ' ' + meses[parseInt(parts[1]) - 1] + ' ' + parts[0];
    },
    personasFiltradas: function() {
      var self = this;
      if (!this.datos || !this.datos.personas) return [];
      return this.datos.personas.filter(function(p) { return !self.personasOcultas[p.codigo]; });
    },
    personasOcultasLista: function() {
      var self = this;
      if (!this.datos || !this.datos.personas) return [];
      return this.datos.personas.filter(function(p) { return self.personasOcultas[p.codigo]; });
    },
    numOcultas: function() {
      var c = 0; for (var k in this.personasOcultas) { if (this.personasOcultas[k]) c++; } return c;
    },
    // La API avisa cuando no ha podido calcular el objetivo del mes (sin OEB o sin ausencias). En
    // ese caso llega a 0, y un 0 en Obj/día se lee como "hoy no tienes que planificar nada" y el
    // cumplimiento saldría rojo para todo el mundo. Se pinta "n/d" y sin color.
    objetivoFiable: function() {
      return !this.datos || this.datos.objetivoFiable !== false;
    },
    instFiltradas: function() {
      var q = (this.buscarInstr || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) {
        return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1;
      });
    },
    horasVisibles: function() {
      if (!this.datos || !this.datos.personas) return [];
      var minH = 23, maxH = 0;
      this.datos.personas.forEach(function(p) {
        if (!p.porHora) return;
        Object.keys(p.porHora).forEach(function(k) {
          var h = parseInt(k);
          if (h < minH) minH = h;
          if (h > maxH) maxH = h;
        });
      });
      if (minH > maxH) { minH = 7; maxH = 18; }
      minH = Math.max(0, minH - 1);
      maxH = Math.min(23, maxH + 1);
      var horas = [];
      for (var i = minH; i <= maxH; i++) horas.push(i);
      return horas;
    }
  },
  methods: {
    onPageInit: function() {
      // Restaurar config guardada
      var configSaved = localStorage.getItem('planDiaria_config');
      if (configSaved) {
        try {
          var cfg = JSON.parse(configSaved);
          // cfg.personasOcultas ya no se lee: la lista de ocultos vive en la config del mes, que
          // es la que comparte con Productividad Planificación. Las que quedaran guardadas aquí de
          // antes se ignoran.
          if (cfg.zoom) this.zoom = cfg.zoom;
          if (cfg.autoRefresh !== undefined) this.autoRefresh = cfg.autoRefresh;
        } catch(e) {}
      }
      // Restaurar estado navegación pedido
      var estadoGuardado = sessionStorage.getItem('planDiaria_estado');
      if (estadoGuardado) {
        try {
          var estado = JSON.parse(estadoGuardado);
          if (estado.fechaStr) this.fechaStr = estado.fechaStr;
          this._scrollRestaurar = estado.scrollTop || 0;
        } catch(e) {}
        sessionStorage.removeItem('planDiaria_estado');
      }
      this.cargarDatos();
      this.setupAutoRefresh();
    },
    cargarDatos: function() {
      var self = this;
      var fechaPedida = self.fechaStr;
      var parts = fechaPedida.split('-');
      if (parts.length !== 3) return;
      var anio = parseInt(parts[0]);
      var mes = parseInt(parts[1]);
      // Cada carga lleva su número. La fecha no basta para distinguirlas: al agotarse el tope de
      // espera, Reintentar lanza una segunda petición para esa misma fecha, y sin este número la
      // primera —que sigue viva— cancelaría el tope de la segunda y pintaría por encima de ella.
      self._cargaId = (self._cargaId || 0) + 1;
      var cargaId = self._cargaId;
      // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then`
      // que lo soltaba y la instancia (`keepAlive`) lo conservaría puesto en la cuenta siguiente.
      cerrojoDeLaSesion(self, 'cargando');
      self.errorCarga = null;
      self.armarEsperaMaxima(fechaPedida, cargaId);
      // Esta pantalla se anuncia como "datos en vivo", así que ninguna carga puede servirse de la
      // caché de peticiones (60 s de sendRequest): el día lo tocan varios planificadores a la vez y
      // pulsar Actualizar, volver a entrar o reintentar dentro de ese minuto devolvería la foto
      // anterior bajo el sello. Cubre además el reintento tras agotarse el tope de espera: una
      // petición colgada deja su promesa pendiente en esa caché y Reintentar se enganchaba a ella.
      Oeb.getPlanificacionDiaria(anio, mes, parseInt(parts[2]), true)
        .then(function(res) {
          // Al pasar meses deprisa, la respuesta de una carga anterior puede llegar después que la
          // de la carga en curso: pintarla enseñaría datos de otro día, o más viejos que los ya
          // pintados si es de la misma fecha.
          if (self._cargaId !== cargaId || self.fechaStr !== fechaPedida) return;
          self.cancelarEsperaMaxima();
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            self._fechaDatos = fechaPedida;
            // Lo que manda es lo que viene del servidor: es la lista única de toda la empresa, y
            // puede traer cambios de otros usuarios.
            self.sincronizarOcultas();
          }
          self.cargando = false;
          // Una respuesta que llega tarde, después de haber avisado de que no se podía cargar,
          // sigue siendo la buena: se pinta y el aviso desaparece.
          self.errorCarga = null;
          if (self._scrollRestaurar > 0) {
            self.$nextTick(function() {
              if (self.$refs.timelineScroll) self.$refs.timelineScroll.scrollTop = self._scrollRestaurar;
              self._scrollRestaurar = 0;
            });
          } else {
            self.centrarHoraActual();
          }
        }).catch(function(e) {
          if (self._cargaId !== cargaId || self.fechaStr !== fechaPedida) return;
          self.cancelarEsperaMaxima();
          self.cargando = false;
          // Si lo que hay pintado es de otro día, se quita: con la cabecera ya puesta en la fecha
          // nueva, dejarlo sería enseñar las cifras de un día bajo la fecha de otro.
          if (self._fechaDatos !== fechaPedida) { self.datos = null; self._fechaDatos = null; }
          self.errorCarga = (e && e.message) ? e.message : 'El servidor no ha respondido correctamente.';
        });
    },
    /**
     * Arranca el tope de espera de la carga en curso. Al agotarse se deja de girar y se dice que no
     * se ha podido cargar, en vez de quedarse en "Cargando datos..." sin fin: la petición puede no
     * volver nunca (ver ESPERA_MAXIMA_MS) y entonces ni el .then ni el .catch llegan a ejecutarse.
     */
    armarEsperaMaxima: function(fechaPedida, cargaId) {
      var self = this;
      self.cancelarEsperaMaxima();
      self._esperaTimer = setTimeout(function() {
        self._esperaTimer = null;
        if (self._cargaId !== cargaId || self.fechaStr !== fechaPedida || !self.cargando) return;
        self.cargando = false;
        if (self._fechaDatos !== fechaPedida) { self.datos = null; self._fechaDatos = null; }
        self.errorCarga = 'El servidor no ha respondido a tiempo. Puede estar caído o tardando más de la cuenta.';
      }, ESPERA_MAXIMA_MS);
    },
    cancelarEsperaMaxima: function() {
      if (this._esperaTimer) { clearTimeout(this._esperaTimer); this._esperaTimer = null; }
    },
    centrarHoraActual: function() {
      var self = this;
      self.$nextTick(function() {
        var el = self.$refs.timelineScroll;
        if (el) {
          var fila = el.querySelector('.hora-actual');
          if (fila) {
            el.scrollTop = Math.max(0, fila.offsetTop - el.offsetTop - (el.clientHeight / 2) + 24);
          }
        }
      });
    },
    setupAutoRefresh: function() {
      if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
      if (this.autoRefresh) {
        var self = this;
        this.refreshTimer = setInterval(function() { self.cargarDatos(); }, 15 * 60 * 1000);
      }
    },
    limpiarInterval: function() {
      if (this.refreshTimer) { clearInterval(this.refreshTimer); this.refreshTimer = null; }
      this.cancelarEsperaMaxima();
    },
    diaPrevio: function() {
      var d = new Date(this.fechaStr + 'T12:00:00');
      d.setDate(d.getDate() - 1);
      this.fechaStr = d.toISOString().substring(0, 10);
      this.cargarDatos();
    },
    diaSiguiente: function() {
      var d = new Date(this.fechaStr + 'T12:00:00');
      d.setDate(d.getDate() + 1);
      this.fechaStr = d.toISOString().substring(0, 10);
      this.cargarDatos();
    },
    irAHoy: function() {
      this.fechaStr = new Date().toISOString().substring(0, 10);
      this.cargarDatos();
    },
    esHoraActual: function(h) {
      var hoy = new Date();
      var parts = this.fechaStr.split('-');
      return hoy.getFullYear() === parseInt(parts[0]) && (hoy.getMonth() + 1) === parseInt(parts[1]) && hoy.getDate() === parseInt(parts[2]) && hoy.getHours() === h;
    },
    esHoraFutura: function(h) {
      var hoy = new Date();
      var parts = this.fechaStr.split('-');
      if (hoy.getFullYear() !== parseInt(parts[0]) || (hoy.getMonth() + 1) !== parseInt(parts[1]) || hoy.getDate() !== parseInt(parts[2])) return false;
      return h > hoy.getHours();
    },
    getTotalHoraPersona: function(persona, hora) {
      if (!persona.porHora || !persona.porHora[String(hora)]) return 0;
      var t = 0;
      persona.porHora[String(hora)].forEach(function(item) { t += (item.importe || 0); });
      return t;
    },
    getCountHoraPersona: function(persona, hora) {
      if (!persona.porHora || !persona.porHora[String(hora)]) return 0;
      return persona.porHora[String(hora)].length;
    },
    getTotalHora: function(hora) {
      var self = this;
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getTotalHoraPersona(p, hora); });
      return t;
    },
    getColorCeldaHora: function(persona, hora) {
      var totalHora = this.getTotalHoraPersona(persona, hora);
      if (totalHora <= 0) return 'transparent';
      // Sin objetivo fiable no hay contra qué comparar: gris. Verde diría "vas bien" justo cuando
      // las tarjetas ponen n/d y la etiqueta dice OBJ. NO DISPONIBLE.
      if (!this.objetivoFiable) return '#94a3b8';
      // Quien hoy no trabaja puede tener horas confirmadas igualmente, y su objetivo es 0. Pintarlas
      // de verde las leería como cumplimiento cuando la tarjeta y el total del día tratan la
      // ausencia como estado neutro: el mismo gris que ellos.
      if (persona.ausenciaHoy) return '#94a3b8';
      var objHora = this.getObjHora(persona);
      // Sin objetivo por hora tampoco hay contra qué comparar (alguien sin %Obj en el mes): gris.
      if (objHora <= 0) return '#94a3b8';
      var pct = (totalHora / objHora) * 100;
      if (pct > 100) return '#17A2B8';
      if (pct >= 98) return '#28A745';
      if (pct >= 94) return '#FFC107';
      return '#DC3545';
    },
    getClaseCeldaHora: function(persona, hora) {
      var totalHora = this.getTotalHoraPersona(persona, hora);
      if (totalHora <= 0) return '';
      var objHora = this.getObjHora(persona);
      if (objHora <= 0) return 'celda-good';
      var pct = (totalHora / objHora) * 100;
      if (pct > 100) return 'celda-excellent';
      if (pct >= 98) return 'celda-good';
      if (pct >= 94) return 'celda-warning';
      return 'celda-critical';
    },
    /** Por qué el objetivo del día es 0: vacaciones, baja, fiesta o fin de semana. */
    textoAusencia: function(tipo) {
      if (tipo === 'vac') return 'Vacaciones';
      if (tipo === 'bl') return 'Baja';
      if (tipo === 'fiesta') return 'Fiesta';
      if (tipo === 'finde') return 'Fin de semana';
      return 'Ausente';
    },
    /**
     * La frase que acompaña al 0 del día. Un sábado no trabaja nadie, así que no hay entre quién
     * repartir: decir que su parte se reparte sería mentira.
     */
    explicacionAusencia: function(tipo) {
      if (tipo === 'finde') return 'Fin de semana: no se trabaja, así que el objetivo del día es 0 € para todos';
      return this.textoAusencia(tipo) + ': su objetivo de hoy es 0 € y su parte se reparte entre los que sí trabajan';
    },
    /**
     * El cumplimiento del día en texto. Quien hoy no trabaja no tiene objetivo contra el que
     * medirse: un 0% se leería como "no ha hecho nada", cuando lo que pasa es que está de
     * vacaciones y su parte la han absorbido los demás.
     */
    txtPctCumplDia: function(persona) {
      if (persona.ausenciaHoy) return this.textoAusencia(persona.ausenciaHoy);
      if (!this.objetivoFiable) return 'n/d';
      return this.getPctCumplDia(persona) + '%';
    },
    getColorCumplDia: function(persona) {
      var plan = persona.planificadoHoy || 0;
      var obj = this.objetivoFiable ? (persona.objDia || 0) : 0;
      if (obj <= 0 || plan <= 0) return '#94a3b8';
      var pct = (plan / obj) * 100;
      if (pct > 100) return '#17A2B8';
      if (pct >= 98) return '#28A745';
      if (pct >= 94) return '#FFC107';
      return '#DC3545';
    },
    // Sin objetivo fiable no hay porcentaje que dar: null, y la plantilla pone "n/d" igual que las
    // tarjetas. Un 0% se leería como "no has hecho nada", que es justo lo contrario de lo que pasa.
    getPctCumplDia: function(persona) {
      if (!this.objetivoFiable) return null;
      var plan = persona.planificadoHoy || 0;
      var obj = persona.objDia || 0;
      if (obj <= 0) return 0;
      return Math.round(plan * 1000 / obj) / 10;
    },
    getColorCumplTotal: function() {
      var plan = this.getTotalGeneral();
      var obj = 0;
      if (this.objetivoFiable) this.personasFiltradas.forEach(function(p) { obj += (p.objDia || 0); });
      if (obj <= 0 || plan <= 0) return '#94a3b8';
      var pct = (plan / obj) * 100;
      if (pct > 100) return '#17A2B8';
      if (pct >= 98) return '#28A745';
      if (pct >= 94) return '#FFC107';
      return '#DC3545';
    },
    getPctCumplTotal: function() {
      if (!this.objetivoFiable) return null;
      var plan = this.getTotalGeneral();
      var obj = 0;
      this.personasFiltradas.forEach(function(p) { obj += (p.objDia || 0); });
      if (obj <= 0) return 0;
      return Math.round(plan * 1000 / obj) / 10;
    },
    abrirDetalleHora: function(persona, hora) {
      if (!persona.porHora || !persona.porHora[String(hora)] || !persona.porHora[String(hora)].length) return;
      this.detalleHoraItems = persona.porHora[String(hora)];
      this.detalleHoraPersona = persona.codigo + ' \u2014 ' + hora + ':00';
      this.detalleHoraTotal = this.getTotalHoraPersona(persona, hora);
    },
    navegarPedido: function(pedidoId) {
      sessionStorage.setItem('planDiaria_estado', JSON.stringify({
        fechaStr: this.fechaStr,
        scrollTop: this.$refs.timelineScroll ? this.$refs.timelineScroll.scrollTop : 0
      }));
      this.detalleHoraItems = null;
      var self = this;
      self.$nextTick(function() {
        self.$f7router.navigate('/pedidos/view/' + pedidoId + '/');
      });
    },
    abrirInfo: function(event, nombre, desc) {
      if (this.infoData && this.infoData.nombre === nombre) { this.infoData = null; return; }
      this.infoData = { nombre: nombre, desc: desc };
      var rect = event.target.getBoundingClientRect();
      this.infoPos = { position: 'fixed', top: (rect.bottom + 8) + 'px', left: Math.max(10, rect.left - 100) + 'px', zIndex: 300 };
    },
    getObjHora: function(persona) {
      var objDia = persona.objDia || 0;
      var horas = (this.datos && this.datos.horasPlanificacion) || 7;
      return horas > 0 ? Math.round(objDia / horas) : 0;
    },
    guardarConfig: function() {
      // Solo zoom y auto-refresco, que son preferencias de este navegador. Los ocultos NO pasan por
      // aqu\u00ed: viven en el servidor y se guardan solos al ocultar o agregar, para que sean los
      // mismos en las dos pantallas y desde cualquier equipo.
      var config = { zoom: this.zoom, autoRefresh: this.autoRefresh };
      localStorage.setItem('planDiaria_config', JSON.stringify(config));
      this.$f7.toast.create({ text: 'Configuraci\u00f3n guardada', position: 'top', closeTimeout: 1500 }).open();
    },
    // La lista de ocultos la manda la API marcando cada persona con "oculta": es la misma que usa
    // Productividad Planificaci\u00f3n, as\u00ed que ocultar a alguien all\u00ed lo oculta tambi\u00e9n aqu\u00ed.
    sincronizarOcultas: function() {
      var self = this;
      var ocultas = {};
      (this.datos && this.datos.personas ? this.datos.personas : []).forEach(function(p) {
        if (p.oculta) ocultas[p.codigo] = true;
      });
      // Un cambio que todavia no ha contestado MANDA sobre lo que traiga el servidor. El
      // auto-refresco cada 15 minutos puede haber pedido los datos ANTES de que se guardara el
      // cambio: su respuesta trae a la persona como visible y, sin esto, reaparecia en pantalla
      // aunque el guardado hubiera ido bien. Cuando la peticion contesta se sale de aqui y manda
      // otra vez el servidor.
      //
      // Solo mandan los cambios pedidos para ESTE mes: la lista de ocultos es de un mes concreto,
      // y un cambio en vuelo de junio no dice nada de julio. Sin el mes en la clave, ocultar a
      // alguien y cambiar de mes antes de que contestara lo ocultaba tambien en el mes nuevo.
      var prefijo = this.prefijoEnVuelo(this.fechaStr);
      Object.keys(self._ocultasEnVuelo || {}).forEach(function(clave) {
        if (!prefijo || clave.indexOf(prefijo) !== 0) return;
        var codigo = clave.substring(prefijo.length);
        if (self._ocultasEnVuelo[clave]) ocultas[codigo] = true;
        else delete ocultas[codigo];
      });
      this.personasOcultas = ocultas;
    },
    /** Parte de mes de la clave de _ocultasEnVuelo, o null si la fecha no vale. */
    prefijoEnVuelo: function(fechaStr) {
      var parts = (fechaStr || '').split('-');
      if (parts.length !== 3) return null;
      return parseInt(parts[0]) + '-' + parseInt(parts[1]) + '|';
    },
    /** ¿La pantalla sigue en el mes al que se pidió un cambio? */
    mismoMes: function(anio, mes) {
      var parts = (this.fechaStr || '').split('-');
      return parts.length === 3 && parseInt(parts[0]) === anio && parseInt(parts[1]) === mes;
    },
    ocultarPersona: function(codigo) {
      this.cambiarOculta(codigo, true);
    },
    mostrarPersona: function(codigo) {
      this.cambiarOculta(codigo, false);
    },
    // Una detras de otra, no nueve a la vez: cada cambio es su propia peticion, y lanzarlas todas
    // juntas encadenaba hasta nueve avisos de error y dejaba la lista a medias sin saber cuales
    // habian entrado. Si alguna falla se para ahi, se deshace esa y se avisa UNA vez.
    mostrarTodas: function() {
      var self = this;
      var parts = (self.fechaStr || '').split('-');
      if (parts.length !== 3) return;
      var anio = parseInt(parts[0]);
      var mes = parseInt(parts[1]);
      var pendientes = Object.keys(self.personasOcultas).filter(function(codigo) {
        return self.personasOcultas[codigo];
      });
      var siguiente = function() {
        // Si a media cola se ha cambiado de mes, se para. `cambiarOculta` trabaja siempre sobre el
        // mes que hay en pantalla, asi que seguir aqui mostraria en el mes NUEVO a gente que su
        // dueño tenia oculta ahi: se tocaria una lista que nadie ha pedido tocar.
        if (!pendientes.length || !self.mismoMes(anio, mes)) return;
        self.cambiarOculta(pendientes.shift(), false, siguiente);
      };
      siguiente();
    },
    // Cada cambio se manda solo, para esa persona, y va contra la lista de este usuario: nadie
    // más escribe ahí, así que no hace falta cola ni orden. El cambio se ve al pulsar y, si la
    // petición falla, se deshace SOLO ese cambio y se avisa; si se corta sin respuesta no se
    // deshace nada y se recarga, porque puede haberse aplicado igualmente: lo que enseña la
    // pantalla —y lo que sale en el PDF— tiene que ser lo que hay guardado.
    cambiarOculta: function(codigo, ocultar, alTerminar) {
      var self = this;
      var parts = self.fechaStr.split('-');
      if (parts.length !== 3) return;
      var anio = parseInt(parts[0]);
      var mes = parseInt(parts[1]);
      var estabaOculta = !!self.personasOcultas[codigo];
      if (estabaOculta === ocultar) return;
      self.$set(self.personasOcultas, codigo, ocultar);
      if (!self._ocultasEnVuelo) self._ocultasEnVuelo = {};
      // La clave lleva el mes: lo que se ha pedido es ocultar a alguien en ESTE mes, y solo la
      // carga de este mes tiene que hacerle caso (ver sincronizarOcultas).
      var clave = anio + '-' + mes + '|' + codigo;
      self._ocultasEnVuelo[clave] = ocultar;
      var peticion = ocultar
        ? Oeb.ocultarPersonaProductividadPlan(anio, mes, codigo)
        : Oeb.mostrarPersonaProductividadPlan(anio, mes, codigo);
      peticion.then(function() {
        delete self._ocultasEnVuelo[clave];
        if (alTerminar) alTerminar();
      }).catch(function(err) {
        delete self._ocultasEnVuelo[clave];
        // La vuelta atrás es del mes al que se pidió el cambio. Si para cuando falla ya se ha
        // navegado a otro mes, personasOcultas es la de ese otro mes y deshacer ahí mostraría o
        // escondería a quien no toca —y con ello el PDF— hasta la siguiente recarga.
        if (!self.mismoMes(anio, mes)) return;
        // Si la petición se cortó sin respuesta no se sabe si el cambio se aplicó, así que
        // deshacerlo puede dejar la pantalla enseñando justo lo contrario de lo guardado.
        // Se relee el día, que es la única forma de saber qué quedó.
        if (Oeb.esResultadoIncierto(err)) {
          self.$f7.toast.create({
            text: (err && err.message) || 'La petición no ha respondido; se recarga para ver si el cambio se aplicó',
            position: 'top', closeTimeout: 4000
          }).open();
          self.cargarDatos();
          return;
        }
        self.$set(self.personasOcultas, codigo, estabaOculta);
        self.$f7.toast.create({
          text: 'No se pudo cambiar la lista de planificadores', position: 'top', closeTimeout: 2000
        }).open();
      });
    },
    cargarInstrucciones: function() {
      var self = this;
      Oeb.getInstrucciones('planificacion-diaria').then(function(res) {
        if (unwrapDto(res)) self.instrucciones = unwrapDto(res);
      });
    },
    guardarInstruccion: function(inst) {
      var self = this;
      if (inst.id) {
        Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto })
          .then(function() { self.$f7.toast.create({ text: 'Guardado', position: 'top', closeTimeout: 1500 }).open(); });
      } else {
        inst.pantalla = 'planificacion-diaria';
        inst.orden = self.instrucciones.length;
        Oeb.crearInstruccion(inst)
          .then(function(res) { if (unwrapDto(res) && unwrapDto(res).id) inst.id = unwrapDto(res).id; self.$f7.toast.create({ text: 'Creado', position: 'top', closeTimeout: 1500 }).open(); });
      }
    },
    nuevaInstruccion: function() {
      this.instrucciones.push({ titulo: 'Nuevo apartado', texto: '', pantalla: 'planificacion-diaria', orden: this.instrucciones.length });
      this.expandedInst = this.instrucciones.length - 1;
    },
    eliminarInstruccion: function(inst) {
      var self = this;
      self.$f7.dialog.confirm('Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        if (inst.id) {
          Oeb.eliminarInstruccion(inst.id).then(function() { self.cargarInstrucciones(); });
        } else {
          var idx = self.instrucciones.indexOf(inst);
          if (idx > -1) self.instrucciones.splice(idx, 1);
        }
      });
    },
    moverInstruccion: function(inst, dir) {
      var idx = this.instrucciones.indexOf(inst);
      var newIdx = idx + dir;
      if (newIdx < 0 || newIdx >= this.instrucciones.length) return;
      var arr = this.instrucciones.slice();
      arr.splice(idx, 1);
      arr.splice(newIdx, 0, inst);
      this.instrucciones = arr;
      var ids = arr.filter(function(i) { return i.id; }).map(function(i) { return i.id; });
      if (ids.length > 0) Oeb.reordenarInstrucciones(ids);
    },
    getTotalSemana: function(semana) {
      var t = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.porSemanaDestino && p.porSemanaDestino[String(semana)]) t += p.porSemanaDestino[String(semana)];
      });
      return t;
    },
    getTotalGeneral: function() {
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += (p.planificadoHoy || 0); });
      return t;
    },
    pctClase: function(pct) {
      if (pct > 100) return 'pct-excellent';
      if (pct >= 98) return 'pct-good';
      if (pct >= 94) return 'pct-warning';
      return 'pct-critical';
    },
    fmtNum: function(v) {
      if (v == null || v === 0) return '0';
      if (Math.abs(v) >= 1000) return Math.round(v).toLocaleString('es-ES');
      return Math.round(v).toString();
    },

    // ===================================================================
    // PDF INFORME PLANIFICACION DIARIA
    // ===================================================================
    generarPDF: function() {
      var self = this;
      if (self.generandoPdf) return;
      if (!self.datos) { self.$f7.dialog.alert('Aún no hay datos cargados'); return; }
      cerrojoDeLaSesion(self, 'generandoPdf');
      var parts = self.fechaStr.split('-');
      var anio = parseInt(parts[0], 10);
      var mes = parseInt(parts[1], 10);

      // #663 · Atado a la sesión: con la cancelación, el `catch` pintaba «Error generando PDF» en
      // la cuenta siguiente y el `then` podía abrir el informe de la anterior.
      atarALaSesion(Promise.all([
        self.getLogoBase64(),
        self.fetchProductividadPlanCached(anio, mes),
        self.fetchDatosPdf(anio, mes, parseInt(parts[2], 10))
      ])).then(function(results) {
        var logoB64 = results[0];
        var prodPlan = results[1];
        var datosPdf = results[2] || self.datos;
        var semanasGlobal = self.semanasDelMes(prodPlan);
        var html = self.buildInformeHTML(datosPdf, prodPlan, semanasGlobal, logoB64);
        var win = window.open('', '_blank');
        if (!win) {
          self.$f7.dialog.alert('Permite ventanas emergentes para generar el PDF');
          self.generandoPdf = false;
          return;
        }
        win.document.write(html);
        win.document.close();
        setTimeout(function() {
          try { win.focus(); win.print(); } catch (e) { /* ignore */ }
          self.generandoPdf = false;
        }, 600);
      }).catch(function(err) {
        self.$f7.dialog.alert('Error generando PDF: ' + (err && err.message ? err.message : err));
        self.generandoPdf = false;
      });
    },

    // El informe usa su propia copia del logotipo y no 'static/img/logo.png', que es el de la
    // aplicación entera y lo consolida otra tarea. Así el PDF ya lleva el logotipo nuevo sin
    // arrastrar al resto de pantallas.
    getLogoBase64: function() {
      var self = this;
      if (self.logoBase64Cache !== null) return Promise.resolve(self.logoBase64Cache);
      return fetch('static/img/logo-simecal-2026.png').then(function(r) {
        if (!r.ok) throw new Error('Logo no encontrado');
        return r.blob();
      }).then(function(blob) {
        return new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload = function() { self.logoBase64Cache = reader.result; resolve(reader.result); };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }).catch(function() { self.logoBase64Cache = ''; return ''; });
    },

    fetchProductividadPlan: function(anio, mes) {
      return Oeb.getProductividadPlan(anio, mes)
        .then(function(res) { return res && unwrapDto(res) ? unwrapDto(res) : null; })
        .catch(function() { return null; });
    },

    fetchProductividadPlanCached: function(anio, mes) {
      var key = anio + '-' + mes;
      if (this.prodPlanCache[key]) return Promise.resolve(this.prodPlanCache[key]);
      var self = this;
      return this.fetchProductividadPlan(anio, mes).then(function(res) {
        self.prodPlanCache[key] = res;
        return res;
      });
    },

    fetchDatosPdf: function(anio, mes, dia) {
      return Oeb.getPlanificacionDiariaPdfDatos(anio, mes, dia)
        .then(function(res) { return res && unwrapDto(res) ? unwrapDto(res) : null; })
        .catch(function() { return null; });
    },

    // Objetivo y acumulado por semana DEL MES QUE SE ESTÁ MIRANDO, y solo de ese mes.
    //
    // El objetivo se acaba con el mes y empieza de cero en el siguiente: una semana que cruce el
    // cambio de mes no puede enseñar una cifra que sume los dos. Antes se pedían también el mes
    // anterior y el siguiente y se sumaban las partes, de modo que la semana a caballo mezclaba
    // dos objetivos —y bastaba con que uno de los dos meses no fuera fiable para no poder
    // publicar ninguna cifra—. Ahora cada día cuenta contra su mes: de una semana partida se
    // enseña la parte que cae en el mes abierto.
    //
    // acumSem suma personas[].porDia[d] para los días de la semana presentes en este mes
    // (pp.semanas[].dias, que la API construye solo con días del mes). Es el TOTAL VIVO actual,
    // no el progresivo cerrado a fin de mes de matrizProgresiva.importesAcum. No se filtra por
    // personasOcultas: el informe va en modo "Mostrar todos".
    semanasDelMes: function(pp) {
      var resultado = { objSem: {}, acumSem: {}, noFiableSem: {}, parcialSem: {} };
      if (!pp) return resultado;

      var redObjMen = !!pp.redObjMen;
      var valorPorSemana = function(mapa, sem) {
        if (!mapa) return 0;
        return mapa[String(sem)] || mapa[sem] || 0;
      };
      var diasDelMesPorSemana = {};
      (pp.semanas || []).forEach(function(sem) {
        if (sem.dias && sem.dias.length) diasDelMesPorSemana[sem.semana] = sem.dias;
      });

      // Si el mes no trae un objetivo bueno, ninguna de sus semanas lo tiene. Se marca por los
      // días que aporta y no por el objetivo, porque un mes no fiable llega justamente con los
      // objetivos a cero y así no se detectaría nunca.
      var fiable = this.pdfObjFiable(pp);

      (pp.semanas || []).forEach(function(sem) {
        var nsem = sem.semana;
        var diasSem = diasDelMesPorSemana[nsem] || [];
        if (diasSem.length === 0) return;
        if (!fiable) resultado.noFiableSem[nsem] = true;
        // Semana partida entre dos meses: de ella solo entran estos días, así que su objetivo es
        // el de media semana. Sin decirlo se lee como un bajón de actividad.
        if (diasSem.length < 5) resultado.parcialSem[nsem] = true;

        // Objetivo: la parte de la semana que cae en este mes, que la API sirve ya sumada día a
        // día en sus dos versiones. Igual que la pantalla y que el correo.
        var objParcial = 0;
        var acumParcial = 0;
        (pp.personas || []).forEach(function(p) {
          var objSemPersona = redObjMen
            ? valorPorSemana(p.objetivoPorSemanaRed, nsem)
            : valorPorSemana(p.objetivoPorSemana, nsem);
          objParcial += objSemPersona;
          if (!p.porDia) return;
          diasSem.forEach(function(d) {
            acumParcial += (p.porDia[String(d)] || p.porDia[d] || 0);
          });
        });
        if (objParcial > 0) resultado.objSem[nsem] = objParcial;
        if (acumParcial > 0) resultado.acumSem[nsem] = acumParcial;
      });
      return resultado;
    },

    pdfEsc: function(s) {
      if (s == null) return '';
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    pdfFmtNum: function(n) {
      if (n == null || n === 0) return '0';
      var rounded = Math.round(n);
      var sign = rounded < 0 ? '-' : '';
      var abs = Math.abs(rounded).toString();
      // Formato miles manual con punto — independiente de soporte Intl del navegador receptor
      return sign + abs.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    pdfFmtNumCorto: function(n) {
      if (n == null || n === 0) return '·';
      if (Math.abs(n) >= 1000) return (Math.round(n / 100) / 10).toString().replace('.', ',') + 'k';
      return Math.round(n).toString();
    },
    pdfColorCss: function(pct) {
      if (pct > 105) return '#378ADD';
      if (pct >= 98) return '#97C459';
      if (pct >= 94) return '#EF9F27';
      return '#E24B4A';
    },
    pdfCssUmbral: function(pct) {
      if (pct > 105) return 'bg-azul';
      if (pct >= 98) return 'bg-verde';
      if (pct >= 94) return 'bg-ambar';
      return 'bg-rojo';
    },
    // La pantalla ya pinta "n/d" cuando la API avisa de que no ha podido calcular el objetivo del
    // mes (objetivoFiable=false). El informe tiene que decir lo mismo: si imprimiera el 0 € y el
    // 0 % que salen de un objetivo que no existe, quedaría un PDF circulando que contradice la
    // pantalla y que presenta como resultado real algo que nadie ha calculado.
    pdfObjFiable: function(datos) {
      return !datos || datos.objetivoFiable !== false;
    },
    // Pero el OEB del mes no es un objetivo: es el dato del que se parte, y no se calcula con las
    // ausencias. Cuando lo único que ha fallado es cargarlas, el OEB sigue siendo bueno y la
    // pantalla de Productividad lo enseña; taparlo aquí con "n/d" borraba del informe una cifra
    // conocida y hacía que PDF y pantalla dijeran cosas distintas. Respuestas anteriores a este
    // campo (cachés ya guardadas) no lo traen: para esas vale la fiabilidad global, que es lo que
    // se venía usando, y que en una caché guardada es siempre true.
    pdfOebDisponible: function(datos) {
      if (datos && typeof datos.oebDisponible === 'boolean') return datos.oebDisponible;
      return this.pdfObjFiable(datos);
    },
    pdfObjTxt: function(valor, fiable) {
      return fiable ? this.pdfFmtNum(valor) + ' €' : 'n/d';
    },
    pdfPctTxt: function(pct, fiable) {
      return fiable ? pct + '%' : 'n/d';
    },
    /** Como pdfPctTxt, pero quien hoy no trabaja sale con el motivo en vez de con un 0% enganoso. */
    pdfPctPersonaTxt: function(persona, fiable) {
      if (persona.ausenciaHoy) return this.textoAusencia(persona.ausenciaHoy);
      return this.pdfPctTxt(persona.pctCumplimiento || 0, fiable);
    },
    pdfColorFiable: function(pct, fiable) {
      return fiable ? this.pdfColorCss(pct) : '#94a3b8';
    },
    pdfUmbralFiable: function(pct, fiable) {
      return fiable ? this.pdfCssUmbral(pct) : 'bg-gris';
    },
    // Quien hoy no trabaja no incumple nada: su objetivo del día es 0, su porcentaje sale 0 y los
    // umbrales lo pintarían de rojo, que en este informe significa "por debajo del objetivo". La
    // pantalla ya lo deja en gris (borde de la tarjeta e insignia del motivo); el PDF tiene que
    // decir lo mismo, o sale "Vacaciones" enmarcado como un incumplimiento.
    pdfColorPersona: function(persona, fiable) {
      if (persona.ausenciaHoy) return '#94a3b8';
      return this.pdfColorFiable(persona.pctCumplimiento || 0, fiable);
    },
    pdfUmbralPersona: function(persona, fiable) {
      if (persona.ausenciaHoy) return 'bg-gris';
      return this.pdfUmbralFiable(persona.pctCumplimiento || 0, fiable);
    },
    pdfAvisoObjetivo: function() {
      return '<div style="margin:6px 0;padding:6px 10px;background:#fdeaea;border-left:4px solid #dc3545;'
        + 'border-radius:3px;font-size:9px;color:#991b1b">'
        + '<b>OBJ. NO DISPONIBLE</b> — no se ha podido calcular el objetivo del mes, así que el Obj/día '
        + 'y el cumplimiento salen como <b>n/d</b>. Lo confirmado sí es correcto.'
        + '</div>';
    },
    // Obj/día que hay que enseñar: con RED.OBJ.MEN guardado es el redistribuido, que es el que
    // enseña Productividad Planificación. Si no viene (respuesta antigua en caché), el de siempre.
    pdfObjDiaProdPlan: function(pp, persona) {
      if (pp && pp.redObjMen && persona.objDiaRed != null) return persona.objDiaRed;
      return persona.objDia || 0;
    },
    // Y el objetivo DEL MES, con el mismo criterio. Sin esto, el PDF coloreaba los dias con el
    // objetivo redistribuido pero calculaba el % de la fila y el total del mes con el objetivo sin
    // redistribuir: la fila OBJ/DIA sumaba una cosa y la casilla de su derecha decia otra.
    pdfObjetivoProdPlan: function(pp, persona) {
      if (pp && pp.redObjMen && persona.objetivoRed != null) return persona.objetivoRed;
      return persona.objetivo || 0;
    },
    // Y el objetivo de UN dia: 0 si ese dia no trabaja y, con RED.OBJ.MEN, con la parte de quien
    // falta ese dia ya sumada. Es el campo objDiaPorDia que calcula la API
    // (OebObjetivosPlanificadoresService#repartirPorDias) y del que beben las tarjetas de
    // Planificacion Diaria y las celdas de Productividad; sin el, el informe restaba al ausente
    // pero no repartia su parte, asi que el objetivo del dia salia mas bajo que en pantalla y los
    // colores mas benevolos. Las respuestas antiguas en cache no lo traen: para esas se sigue con
    // el Obj/dia del mes, que es lo que hacia el PDF hasta ahora.
    pdfObjDiaProdPlanDia: function(pp, persona, dia) {
      var porDia = (pp && pp.redObjMen && persona.objDiaPorDiaRed) ? persona.objDiaPorDiaRed : persona.objDiaPorDia;
      if (porDia) {
        var v = porDia[String(dia)];
        if (v == null) v = porDia[dia];
        if (v != null) return v;
      }
      if (persona.ausenciasPorDia && persona.ausenciasPorDia[String(dia)] != null) return 0;
      return this.pdfObjDiaProdPlan(pp, persona);
    },

    buildCssPdf: function() {
      return ''
        + '@page portrait-default { size: A4 portrait; margin: 12mm 10mm; }'
        + '@page landscape-page { size: A4 landscape; margin: 10mm 10mm; }'
        + '@media print {'
        +   '* { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }'
        +   'body { margin: 0; }'
        +   '.pagina-landscape { page: landscape-page; }'
        + '}'
        + '* { box-sizing: border-box; }'
        + 'body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color: #1a2744; font-size: 10px; }'
        + 'table { border-collapse: collapse; width: 100%; }'
        + 'th, td { padding: 4px 6px; vertical-align: middle; }'
        + 'section { page-break-inside: auto; }'
        + '.pb { page-break-before: always; }'
        + '.pagina-landscape { page-break-before: always; page: landscape-page; }'
        + '.hdr { background: #1a2744; color: #fff; padding: 12px 16px; }'
        // El logotipo es azul marino y la banda de la cabecera también, así que va sobre un
        // recuadro blanco, igual que en el correo. El ancho y el alto salen de la proporción del
        // fichero (901x976): si se cambia uno hay que recalcular el otro o sale deformado.
        + '.hdr-logo-caja { background: #ffffff; border-radius: 5px; padding: 6px 8px; display: inline-block; }'
        + '.hdr-logo { width: 48px; height: 52px; display: block; }'
        + '.hdr-titulo { font-size: 19px; font-weight: 700; letter-spacing: 0.3px; line-height: 1.2; }'
        + '.hdr-fecha { font-size: 12px; font-weight: 600; color: #e5e9f0; text-align: right; }'
        + '.seccion-tit { font-size: 11px; font-weight: 700; color: #1a2744; text-transform: uppercase; letter-spacing: 0.8px; margin: 10px 0 6px; border-bottom: 1px solid #cbd5e1; padding-bottom: 3px; }'
        + '.kpi-box { border: 1px solid #dee2e6; border-radius: 4px; padding: 8px 10px; }'
        + '.kpi-lbl { font-size: 8px; color: #64748b; text-transform: uppercase; letter-spacing: 0.6px; }'
        + '.kpi-val { font-size: 14px; font-weight: 700; color: #1a2744; margin-top: 2px; }'
        + '.bar-track { background: #eef1f7; border-radius: 4px; height: 10px; overflow: hidden; }'
        + '.bar-fill { height: 100%; }'
        + '.tarjeta-pers { border: 1px solid #dde3ec; border-radius: 6px; padding: 8px 10px; }'
        + '.tarjeta-cod { font-size: 16px; font-weight: 800; color: #1a2744; letter-spacing: -0.4px; }'
        + '.tarjeta-nom { font-size: 9px; color: #64748b; margin-top: 1px; }'
        + '.tarj-kpi-lbl { font-size: 8px; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; display: block; }'
        + '.tarj-kpi-val { font-size: 13px; font-weight: 700; color: #1a2744; }'
        + '.tbl-datos th { background: #1a2744; color: #fff; font-size: 8px; font-weight: 600; text-align: left; text-transform: uppercase; letter-spacing: 0.4px; padding: 5px 6px; }'
        + '.tbl-datos td { font-size: 9px; border-bottom: 1px solid #eef0f5; }'
        + '.tbl-datos tr.sub td { background: #f4f6fa; font-weight: 700; }'
        + '.tbl-datos tfoot tr.tot td { background: #1a2744; color: #fff; font-weight: 700; font-size: 11px; padding: 7px 6px; }'
        + '.tbl-datos tfoot { display: table-row-group; }'
        + 'tfoot, tfoot tr, tfoot td { page-break-inside: avoid !important; }'
        + '.tbl-matriz { font-size: 8px; }'
        + '.tbl-matriz th { background: #1a2744; color: #fff; padding: 4px 2px; font-weight: 700; text-align: center; font-size: 8px; }'
        + '.tbl-matriz td { padding: 3px 2px; text-align: center; border: 1px solid #eef0f5; font-size: 8px; }'
        + '.celda-excellent { background: #D8EAF9; color: #185FA5; font-weight: 700; }'
        + '.celda-good { background: #EAF3DE; color: #3B6D11; font-weight: 700; }'
        + '.celda-warning { background: #FDF0D8; color: #8B5A00; font-weight: 700; }'
        + '.celda-critical { background: #FCEBEB; color: #A32D2D; font-weight: 700; }'
        + '.celda-ausencia { background: #fff8e1; color: #92400e; font-weight: 700; font-style: italic; }'
        + '.celda-finde { background: #f1f5f9; color: #94a3b8; }'
        + '.celda-hoy { outline: 2px solid #f59e0b; outline-offset: -2px; }'
        + '.fila-total-mat td { background: #1a2744 !important; color: #fff !important; font-weight: 700 !important; border-top: 2px solid #1a2744; }'
        + '.fila-obj-mat td { background: #f8fafc !important; color: #64748b !important; font-style: italic; }'
        + '.bg-azul { background: #378ADD; color: #fff; }'
        + '.bg-verde { background: #97C459; color: #1a2744; }'
        + '.bg-ambar { background: #EF9F27; color: #1a2744; }'
        + '.bg-rojo { background: #E24B4A; color: #fff; }'
        + '.bg-gris { background: #e5e7eb; color: #64748b; }'
        + '.badge { display: inline-block; padding: 2px 7px; border-radius: 10px; font-size: 9px; font-weight: 700; }'
        + '.pie { margin-top: 12px; border-top: 1px solid #cbd5e1; padding-top: 4px; font-size: 7px; color: #64748b; text-align: center; }'
        + '.timeline td { font-size: 8px; text-align: center; border: 1px solid #eef0f5; padding: 3px 1px; }'
        + '.timeline th { font-size: 8px; text-align: center; background: #1a2744; color: #fff; padding: 4px 1px; border: 1px solid #2a3754; }'
        + '.timeline td.val { background: #F5F8FC; font-weight: 600; color: #1a2744; }'
        + '.timeline td.pico { background: #D8ECC6; font-weight: 700; color: #1a2744; }'
        + '.col-total-hora { background: #0F6E56 !important; color: #fff !important; font-weight: 700 !important; }'
        + '.col-total-row td { background: #1a2744; color: #fff; font-weight: 700; }'
        + '.fila-sem-obj td { background: #f8fafc; color: #64748b; font-style: italic; }'
        + '.fila-sem-dif td { background: #fff; font-weight: 600; }'
        + '.fila-sem-pct td { background: #fff; }';
    },

    buildInformeHTML: function(d, prodPlan, semanasGlobal, logoB64) {
      var parts = this.fechaStr.split('-');
      var anio = parseInt(parts[0], 10);
      var mes = parseInt(parts[1], 10);
      var dia = parseInt(parts[2], 10);
      return '<!DOCTYPE html>'
        + '<html><head><meta charset="UTF-8">'
        + '<title>Informe Planificación Diaria OEB — ' + dia + '/' + mes + '/' + anio + '</title>'
        + '<style>' + this.buildCssPdf() + '</style>'
        + '</head><body>'
        + this.buildP1Html(d, logoB64, anio, mes, dia)
        + this.buildP2Html(d, logoB64, anio, mes, dia)
        + this.buildP3Html(d, prodPlan, semanasGlobal, logoB64, anio, mes, dia)
        + (prodPlan ? this.buildP4Html(prodPlan, logoB64, anio, mes, dia) : '')
        + '</body></html>';
    },

    buildCabecera: function(logoB64, titulo, anio, mes, dia, diaSemana, semana) {
      var MESES = ['','enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      var fechaFull = dia + ' de ' + MESES[mes] + ' de ' + anio;
      if (diaSemana) fechaFull += ' · ' + diaSemana + ' · S' + semana;
      return '<table class="hdr" style="border-collapse:separate"><tr>'
        + (logoB64 ? '<td style="width:76px;vertical-align:middle"><span class="hdr-logo-caja"><img src="' + logoB64 + '" class="hdr-logo"/></span></td>' : '')
        + '<td style="vertical-align:middle"><div class="hdr-titulo">' + this.pdfEsc(titulo) + '</div></td>'
        + '<td style="vertical-align:middle;text-align:right"><div class="hdr-fecha">' + fechaFull + '</div></td>'
        + '</tr></table>';
    },

    buildPie: function(anio, mes, dia) {
      var MESES_CORTO = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      var hoy = new Date();
      var hoyStr = hoy.toLocaleDateString('es-ES') + ' ' + hoy.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      return '<div class="pie">SIMECAL · Informe Planificación Diaria · ' + dia + ' ' + MESES_CORTO[mes] + ' ' + anio + ' · Generado ' + hoyStr + '</div>';
    },

    buildKpiBox: function(label, value, colorVal) {
      var style = colorVal ? ';color:' + colorVal : '';
      return '<td style="width:20%;padding:3px"><div class="kpi-box"><div class="kpi-lbl">' + this.pdfEsc(label) + '</div><div class="kpi-val" style="' + style + '">' + this.pdfEsc(value) + '</div></div></td>';
    },

    buildP1Html: function(d, logoB64, anio, mes, dia) {
      var self = this;
      var personas = d.personas || [];
      var visibles = personas.filter(function(p) { return !self.personasOcultas[p.codigo]; });
      var oebMes = d.oebMes || 0;
      var objTotal = d.objTotal || 0;
      var hPlanif = d.horasPlanificacion || 7;
      var fiable = this.pdfObjFiable(d);
      var planifHoy = 0, objDiaTotal = 0;
      visibles.forEach(function(p) { planifHoy += (p.planificadoHoy || 0); objDiaTotal += (p.objDia || 0); });
      var pctDia = objDiaTotal > 0 ? Math.round(planifHoy / objDiaTotal * 1000) / 10 : 0;

      var html = '<section>';
      html += this.buildCabecera(logoB64, 'Informe de Planificación Diaria', anio, mes, dia, d.diaSemana, d.semanaActual);
      if (!fiable) html += this.pdfAvisoObjetivo();

      html += '<div class="seccion-tit">Resumen del día</div>';
      html += '<table><tr>';
      html += this.buildKpiBox('OEB Mes', this.pdfObjTxt(oebMes, this.pdfOebDisponible(d)));
      html += this.buildKpiBox('Obj.planif mes', this.pdfObjTxt(objTotal, fiable));
      html += this.buildKpiBox('Obj. día', this.pdfObjTxt(objDiaTotal, fiable));
      html += this.buildKpiBox('Confirmado hoy', this.pdfFmtNum(planifHoy) + ' €');
      html += this.buildKpiBox('% Cumpl.', this.pdfPctTxt(pctDia, fiable), this.pdfColorFiable(pctDia, fiable));
      html += '</tr></table>';

      html += '<div class="seccion-tit">Cumplimiento por planificador</div>';
      html += '<table>';
      visibles.forEach(function(p) {
        var pct = p.pctCumplimiento || 0;
        var pctDisplay = fiable ? Math.min(100, Math.max(0, Math.round(pct))) : 0;
        var color = self.pdfColorPersona(p, fiable);
        html += '<tr>'
          + '<td style="width:60px;font-size:10px;font-weight:700;color:#1a2744">' + self.pdfEsc(p.codigo) + '</td>'
          + '<td><div class="bar-track"><div class="bar-fill" style="width:' + pctDisplay + '%;background:' + color + '"></div></div></td>'
          + '<td style="width:70px;text-align:right;font-size:10px;font-weight:700;color:' + color + '">' + self.pdfPctPersonaTxt(p, fiable) + '</td>'
          + '<td style="width:110px;text-align:right;font-size:9px;color:#64748b">' + self.pdfFmtNum(p.planificadoHoy) + ' / ' + (fiable ? self.pdfFmtNum(p.objDia) : 'n/d') + '</td>'
          + '</tr>';
      });
      html += '</table>';

      html += '<div class="seccion-tit">Distribución horaria (importe confirmado)</div>';
      var porHora = {};
      visibles.forEach(function(p) {
        if (!p.porHora) return;
        Object.keys(p.porHora).forEach(function(k) {
          var h = parseInt(k, 10);
          var items = p.porHora[k] || [];
          var sum = 0;
          items.forEach(function(it) { sum += (it.importe || 0); });
          porHora[h] = (porHora[h] || 0) + sum;
        });
      });
      var maxH = 1;
      Object.keys(porHora).forEach(function(k) { if (porHora[k] > maxH) maxH = porHora[k]; });
      html += '<table><tr>';
      for (var h = 8; h <= 18; h++) {
        var val = porHora[h] || 0;
        var altura = Math.round(val * 60 / maxH);
        html += '<td style="text-align:center;vertical-align:bottom;width:9%">'
          + '<div style="height:' + (60 - altura) + 'px"></div>'
          + '<div style="height:' + Math.max(2, altura) + 'px;background:#378ADD;width:70%;margin:0 auto"></div>'
          + '<div style="font-size:7px;color:#64748b;margin-top:2px">' + this.pdfFmtNumCorto(val) + '</div>'
          + '<div style="font-size:8px;font-weight:700;color:#1a2744;margin-top:1px">' + h + 'h</div>'
          + '</td>';
      }
      html += '</tr></table>';

      html += '<div class="seccion-tit">Planificadores activos (' + visibles.length + ')</div>';
      html += '<table style="border-spacing:6px;border-collapse:separate">';
      for (var i = 0; i < visibles.length; i += 2) {
        html += '<tr>';
        for (var j = 0; j < 2; j++) {
          if (i + j >= visibles.length) { html += '<td style="width:50%"></td>'; continue; }
          var p = visibles[i + j];
          var objHora = hPlanif > 0 ? Math.round((p.objDia || 0) / hPlanif) : 0;
          html += '<td style="width:50%;vertical-align:top"><div class="tarjeta-pers" style="border-left:4px solid ' + self.pdfColorPersona(p, fiable) + '">'
            + '<table style="width:100%"><tr>'
            + '<td><div class="tarjeta-cod">' + self.pdfEsc(p.codigo) + '</div>'
            + '<div class="tarjeta-nom">' + self.pdfEsc(p.nombre) + '</div></td>'
            + '<td style="text-align:right"><span class="badge ' + self.pdfUmbralPersona(p, fiable) + '" style="font-size:11px;padding:3px 10px">' + self.pdfPctPersonaTxt(p, fiable) + '</span></td>'
            + '</tr></table>'
            + '<table style="width:100%;margin-top:6px;border-collapse:separate;border-spacing:6px 0"><tr>'
            + '<td style="width:33%"><span class="tarj-kpi-lbl">Obj. día</span><div class="tarj-kpi-val">' + self.pdfObjTxt(p.objDia, fiable) + '</div></td>'
            + '<td style="width:34%"><span class="tarj-kpi-lbl">Confirmado hoy</span><div class="tarj-kpi-val" style="color:#198754;font-size:16px">' + self.pdfFmtNum(p.planificadoHoy) + ' €</div></td>'
            + '<td style="width:33%"><span class="tarj-kpi-lbl">Obj/hora</span><div class="tarj-kpi-val" style="color:#2d5f8a">' + (fiable ? self.pdfFmtNum(objHora) : 'n/d') + '</div></td>'
            + '</tr></table>'
            + (p.ppendHoy > 0
                ? '<div style="text-align:right;margin-top:4px;font-size:9px;color:#856404">'
                    + '<span style="background:#FFF3CD;border:1px solid #FFEEBA;border-radius:3px;padding:1px 5px;font-weight:700;letter-spacing:0.3px;margin-right:4px">OEB PPEND</span>'
                    + '<span style="font-size:11px;font-weight:700">' + self.pdfFmtNum(p.ppendHoy) + ' &euro;</span>'
                  + '</div>'
                : '')
            + '</div></td>';
        }
        html += '</tr>';
      }
      html += '</table>';
      html += this.buildPie(anio, mes, dia);
      html += '</section>';
      return html;
    },

    buildP2Html: function(d, logoB64, anio, mes, dia) {
      var self = this;
      var personas = d.personas || [];
      var visibles = personas.filter(function(p) { return !self.personasOcultas[p.codigo]; });
      var conDatos = visibles.filter(function(p) { return p.porHora && Object.keys(p.porHora).length > 0; });
      var fiable = this.pdfObjFiable(d);
      var html = '';
      conDatos.forEach(function(p, idx) {
        html += '<section class="' + (idx === 0 ? 'pb' : 'pb') + '">';
        html += self.buildCabecera(logoB64, 'Detalle de pedidos — ' + p.codigo, anio, mes, dia, d.diaSemana, d.semanaActual);
        html += '<div class="seccion-tit">' + self.pdfEsc(p.codigo) + ' · ' + self.pdfEsc(p.nombre)
          + ' · Confirmado: <b>' + self.pdfFmtNum(p.planificadoHoy) + '€</b>'
          + ' · Obj. día: <b>' + (fiable ? self.pdfFmtNum(p.objDia) + '€' : 'n/d') + '</b>'
          + ' · Cumpl.: <b>' + self.pdfPctPersonaTxt(p, fiable) + '</b></div>';

        html += '<table class="tbl-datos" style="table-layout:fixed"><thead><tr>'
          + '<th style="width:8%">Hora</th>'
          + '<th style="width:13%">Pedido SAP</th>'
          + '<th style="width:23%">Cliente</th>'
          + '<th style="width:8%">Materia</th>'
          + '<th style="width:35%">Servicio</th>'
          + '<th style="width:13%;text-align:right">Importe (€)</th>'
          + '</tr></thead><tbody>';

        var horas = Object.keys(p.porHora).map(function(k) { return parseInt(k, 10); }).sort(function(a, b) { return a - b; });
        var totalPersona = 0;
        horas.forEach(function(h) {
          var items = p.porHora[h] || p.porHora[String(h)] || [];
          var subt = 0;
          items.forEach(function(it) {
            var sap = (it.numeroPedidoSap && String(it.numeroPedidoSap).trim()) ? String(it.numeroPedidoSap) : '—';
            var cliente = (it.cliente && String(it.cliente).trim()) ? String(it.cliente) : '—';
            var materia = (it.materia && String(it.materia).trim()) ? String(it.materia) : '—';
            var servicio = (it.servicio && String(it.servicio).trim()) ? String(it.servicio) : '—';
            html += '<tr>'
              + '<td>' + self.pdfEsc(it.hora) + '</td>'
              + '<td>' + self.pdfEsc(sap) + '</td>'
              + '<td style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + self.pdfEsc(cliente) + '</td>'
              + '<td>' + self.pdfEsc(materia) + '</td>'
              + '<td style="white-space:normal;word-break:break-word;line-height:1.2">' + self.pdfEsc(servicio) + '</td>'
              + '<td style="text-align:right;white-space:nowrap">' + self.pdfFmtNum(it.importe) + ' €</td>'
              + '</tr>';
            subt += (it.importe || 0);
          });
          html += '<tr class="sub"><td colspan="5">Subtotal ' + (h < 10 ? '0' + h : h) + ':00</td>'
            + '<td style="text-align:right;white-space:nowrap">' + self.pdfFmtNum(subt) + ' €</td></tr>';
          totalPersona += subt;
        });
        html += '</tbody><tfoot><tr class="tot"><td colspan="5">TOTAL</td>'
          + '<td style="text-align:right;white-space:nowrap">' + self.pdfFmtNum(totalPersona) + ' €</td></tr></tfoot>';
        html += '</table>';
        html += self.buildPie(anio, mes, dia);
        html += '</section>';
      });
      return html;
    },

    buildP3Html: function(d, pp, semanasGlobal, logoB64, anio, mes, dia) {
      var self = this;
      var personas = d.personas || [];
      var visibles = personas.filter(function(p) { return !self.personasOcultas[p.codigo]; });
      var semActual = d.semanaActual || 0;
      var html = '<section class="pb">';
      html += this.buildCabecera(logoB64, 'Timeline y análisis semanal', anio, mes, dia, d.diaSemana, d.semanaActual);

      // Timeline con colores
      html += '<div class="seccion-tit">Timeline 08h–18h — importe confirmado por hora</div>';
      html += '<table class="timeline"><thead><tr><th style="text-align:left;width:80px">Persona</th>';
      for (var h = 8; h <= 18; h++) html += '<th>' + h + 'h</th>';
      html += '<th class="col-total-hora">Total</th></tr></thead><tbody>';

      var sumaHora = {};
      for (var hh = 8; hh <= 18; hh++) sumaHora[hh] = 0;

      // Primera pasada: calcular sumas por hora para detectar pico
      visibles.forEach(function(p) {
        for (var hx = 8; hx <= 18; hx++) {
          var items = (p.porHora && (p.porHora[hx] || p.porHora[String(hx)])) || [];
          items.forEach(function(it) { sumaHora[hx] += (it.importe || 0); });
        }
      });
      var horaPico = 8, picoVal = 0;
      for (var hp = 8; hp <= 18; hp++) {
        if (sumaHora[hp] > picoVal) { picoVal = sumaHora[hp]; horaPico = hp; }
      }

      visibles.forEach(function(p) {
        html += '<tr><td style="text-align:left;font-weight:700;color:#1a2744;background:#f8fafc">' + self.pdfEsc(p.codigo) + '</td>';
        var total = 0;
        for (var hx = 8; hx <= 18; hx++) {
          var items = (p.porHora && (p.porHora[hx] || p.porHora[String(hx)])) || [];
          var sum = 0;
          items.forEach(function(it) { sum += (it.importe || 0); });
          total += sum;
          var cls = sum > 0 ? (hx === horaPico ? 'pico' : 'val') : '';
          var extra = sum <= 0 ? ' style="color:#cbd5e1"' : '';
          html += '<td class="' + cls + '"' + extra + '>' + (sum > 0 ? self.pdfFmtNumCorto(sum) : '·') + '</td>';
        }
        html += '<td class="col-total-hora">' + self.pdfFmtNum(total) + '</td></tr>';
      });

      html += '<tr class="col-total-row"><td style="text-align:left">TOTAL</td>';
      var granTotal = 0;
      for (var h2 = 8; h2 <= 18; h2++) {
        granTotal += sumaHora[h2];
        var isPico = (h2 === horaPico && sumaHora[h2] > 0) ? ' style="background:#0F6E56;color:#fff"' : '';
        html += '<td' + isPico + '>' + (sumaHora[h2] > 0 ? self.pdfFmtNumCorto(sumaHora[h2]) : '·') + '</td>';
      }
      html += '<td class="col-total-hora">' + self.pdfFmtNum(granTotal) + '</td></tr>';
      html += '</tbody></table>';

      // ===== BLOQUE A — DISPERSIÓN TEMPORAL =====
      var sems = d.semanasVisibles || [];
      var planPorSem = {};
      visibles.forEach(function(p) {
        if (!p.porSemanaDestino) return;
        Object.keys(p.porSemanaDestino).forEach(function(k) {
          var ns = parseInt(k, 10);
          planPorSem[ns] = (planPorSem[ns] || 0) + (p.porSemanaDestino[k] || 0);
        });
      });
      var totalHoy = 0;
      sems.forEach(function(s) { totalHoy += (planPorSem[s.semana] || 0); });

      html += '<div class="seccion-tit">Control semanal — dispersión temporal del confirmado hoy (' + self.pdfFmtNum(totalHoy) + ' €)</div>';

      html += '<table class="tbl-datos" style="table-layout:fixed"><thead><tr><th style="width:130px">Concepto</th>';
      sems.forEach(function(s) {
        var bg = s.semana === semActual ? ';background:#2d5f8a' : '';
        html += '<th style="text-align:center;white-space:nowrap' + bg + '">S' + s.semana + '<br>'
          + '<span style="font-weight:400;color:#c8d3e5;font-size:7px;white-space:nowrap">' + self.pdfEsc(s.inicio) + ' - ' + self.pdfEsc(s.fin) + '</span></th>';
      });
      html += '<th class="col-total-hora" style="width:70px;white-space:nowrap">TOTAL</th>';
      html += '</tr></thead><tbody>';

      // Fila CONFIRMADO HOY
      html += '<tr><td style="font-weight:700">CONFIRMADO HOY</td>';
      sems.forEach(function(s) {
        var v = planPorSem[s.semana] || 0;
        html += '<td style="text-align:center;font-weight:600">' + (v > 0 ? self.pdfFmtNum(v) + ' €' : '—') + '</td>';
      });
      html += '<td class="col-total-hora">' + self.pdfFmtNum(totalHoy) + ' €</td></tr>';

      // Fila % DEL DÍA
      var sumaPct = 0;
      html += '<tr><td style="color:#64748b;font-style:italic">% DEL DÍA</td>';
      sems.forEach(function(s) {
        var v = planPorSem[s.semana] || 0;
        var pct = totalHoy > 0 && v > 0 ? (v / totalHoy * 100) : 0;
        sumaPct += pct;
        html += '<td style="text-align:center;color:#64748b;font-style:italic">' + (pct > 0 ? pct.toFixed(1) + '%' : '—') + '</td>';
      });
      html += '<td class="col-total-hora" style="font-style:italic">' + (totalHoy > 0 ? sumaPct.toFixed(1) + '%' : '—') + '</td></tr>';
      html += '</tbody></table>';

      // Nota aclaratoria si hay planificado fuera del horizonte visible
      if (totalHoy > 0 && granTotal > totalHoy) {
        html += '<div style="font-size:9px;color:#64748b;margin-top:4px;font-style:italic">'
          + '* Suma mostrada corresponde al confirmado hoy con fecha destino dentro de las '
          + sems.length + ' semanas del horizonte. Pedidos sin fecha asignada o en semanas más lejanas no se reflejan.'
          + '</div>';
      }

      // ===== BLOQUE B — PRESIÓN SEMANA EN CURSO =====
      html += '<div class="seccion-tit" style="margin-top:14px">Presión semana en curso — S' + semActual + '</div>';

      // El objetivo semanal sale de Productividad Planificación, así que es su marca de fiabilidad
      // —no la del día— la que decide si se puede enseñar. Si la semana cruza el cambio de mes,
      // esta cifra es solo la parte que cae en el mes abierto: el objetivo termina con el mes.
      var semanaNoFiable = !!(semanasGlobal && semanasGlobal.noFiableSem && semanasGlobal.noFiableSem[semActual]);
      // Sin respuesta de Productividad Planificación no hay objetivo que enseñar: un 0 aquí se
      // leería como "esta semana no hay que planificar nada".
      var ppFiable = !!pp && this.pdfObjFiable(pp) && !semanaNoFiable;
      // Sin promedios de reserva: si esta semana no tiene objetivo en el mes abierto, se dice que
      // no lo hay. Repartir el objetivo del mes entre sus semanas daría a la semana partida una
      // cifra de semana entera, que es justo lo que el objetivo por meses viene a evitar.
      var objSem = (semanasGlobal && semanasGlobal.objSem && semanasGlobal.objSem[semActual]) || 0;
      if (!ppFiable) objSem = 0;
      var acumSem = (semanasGlobal && semanasGlobal.acumSem && semanasGlobal.acumSem[semActual]) || 0;
      var acumDisponible = acumSem > 0 || (semanasGlobal && semanasGlobal.acumSem && typeof semanasGlobal.acumSem[semActual] !== 'undefined');
      var falta = objSem - acumSem;
      var pctCob = objSem > 0 ? Math.round(acumSem / objSem * 1000) / 10 : 0;

      html += '<table style="width:100%;table-layout:fixed;border-collapse:separate;border-spacing:6px 0"><tr>';
      // 1) Objetivo. Si la semana cruza el cambio de mes se dice: si no, su objetivo más bajo
      // —solo los días de este mes— se lee como un bajón de actividad y no como media semana.
      var semParcial = !!(semanasGlobal && semanasGlobal.parcialSem && semanasGlobal.parcialSem[semActual]);
      var notaParcial = (semParcial && ppFiable)
        ? '<div style="font-size:8px;font-weight:600;color:#E65100;margin-top:2px">semana parcial — solo sus días de este mes</div>'
        : '';
      html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #1a2744"><div class="kpi-lbl">Objetivo semanal</div>'
        + '<div class="kpi-val">' + self.pdfObjTxt(objSem, ppFiable) + '</div>' + notaParcial + '</div></td>';
      // 2) Planificado acumulado
      if (acumSem > 0) {
        html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #378ADD"><div class="kpi-lbl">Planificado acumulado</div>'
          + '<div class="kpi-val">' + self.pdfFmtNum(acumSem) + ' €</div></div></td>';
      } else {
        html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #cbd5e1"><div class="kpi-lbl">Planificado acumulado</div>'
          + '<div class="kpi-val" style="color:#94a3b8;font-size:11px">Datos de carga semanal<br>acumulada no disponibles</div></div></td>';
      }
      // 3) Falta por planificar. Sin objetivo (no fiable, o no hay semana en la matriz) no se puede
      // decir cuánto falta: un 0 se leería como "objetivo superado" sin haber objetivo ninguno.
      if (acumSem > 0 && objSem > 0) {
        if (falta > 0) {
          html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #dc3545"><div class="kpi-lbl">Falta por planificar</div>'
            + '<div class="kpi-val" style="color:#dc3545">' + self.pdfFmtNum(falta) + ' €</div></div></td>';
        } else {
          html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #198754"><div class="kpi-lbl">Falta por planificar</div>'
            + '<div class="kpi-val" style="color:#1a2744">0 €</div>'
            + '<div style="font-size:8px;color:#198754;margin-top:2px">✓ Objetivo superado (+' + self.pdfFmtNum(Math.abs(falta)) + ' €)</div></div></td>';
        }
      } else {
        html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid #cbd5e1"><div class="kpi-lbl">Falta por planificar</div>'
          + '<div class="kpi-val" style="color:#94a3b8">—</div></div></td>';
      }
      // 4) % Cobertura
      var cobCls = (acumSem > 0 && objSem > 0) ? self.pdfCssUmbral(pctCob) : 'bg-gris';
      var cobTxt = (acumSem > 0 && objSem > 0) ? pctCob + '%' : '—';
      html += '<td style="width:25%"><div class="kpi-box" style="border-left:3px solid ' + (acumSem > 0 && objSem > 0 ? self.pdfColorCss(pctCob) : '#cbd5e1') + '"><div class="kpi-lbl">% Cobertura</div>'
        + '<div style="margin-top:4px"><span class="badge ' + cobCls + '" style="font-size:13px;padding:4px 12px">' + cobTxt + '</span></div></div></td>';
      html += '</tr></table>';

      html += this.buildPie(anio, mes, dia);
      html += '</section>';
      return html;
    },

    buildP4Html: function(pp, logoB64, anio, mes, dia) {
      var self = this;
      var MESES = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      var personas = (pp && pp.personas) || [];
      var personasVisibles = personas.filter(function(p) { return !self.personasOcultas[p.codigo]; });
      var oebMes = (pp && pp.oebMes) || 0;
      var objTotal = (pp && pp.objetivoTotal) || 0;
      var fiable = this.pdfObjFiable(pp);
      var totalPlan = 0;
      personasVisibles.forEach(function(p) { totalPlan += (p.totalPlan || 0); });
      var falta = objTotal - totalPlan;
      var pctGlob = objTotal > 0 ? Math.round(totalPlan * 1000 / objTotal) / 10 : 0;

      var mp = pp && pp.matrizProgresiva;
      var diasInfo = (mp && mp.diasInfo) || [];
      var hoyDate = new Date();
      var mesActual = (hoyDate.getFullYear() === anio && (hoyDate.getMonth() + 1) === mes);
      var diaHoy = hoyDate.getDate();

      var html = '<section class="pagina-landscape">';
      html += this.buildCabecera(logoB64, 'Registro progresivo — ' + MESES[mes] + ' ' + anio, anio, mes, dia, null, 0);
      if (!fiable) html += this.pdfAvisoObjetivo();

      html += '<table><tr>';
      html += this.buildKpiBox('OEB Mes', this.pdfObjTxt(oebMes, this.pdfOebDisponible(pp)));
      html += this.buildKpiBox('Obj.planif.', this.pdfObjTxt(objTotal, fiable));
      html += this.buildKpiBox('Planificado', this.pdfFmtNum(totalPlan) + ' €');
      html += this.buildKpiBox('% Cumpl.', this.pdfPctTxt(pctGlob, fiable), this.pdfColorFiable(pctGlob, fiable));
      html += this.buildKpiBox('Falta', fiable ? (falta > 0 ? this.pdfFmtNum(falta) : '0') + ' €' : 'n/d');
      html += '</tr></table>';

      if (diasInfo.length > 0 && personasVisibles.length > 0) {
        html += '<div class="seccion-tit">Planificación diaria por persona — ' + diasInfo.length + ' días hábiles (€)</div>';
        html += '<table class="tbl-matriz"><thead>';

        // Fila 1: días del mes
        html += '<tr><th style="width:42px;text-align:left">Cód.</th>';
        diasInfo.forEach(function(di) {
          var esHoy = mesActual && di.dia === diaHoy;
          var outline = esHoy ? ';outline:2px solid #f59e0b;outline-offset:-2px' : '';
          html += '<th style="min-width:24px' + outline + '">' + di.dia + '</th>';
        });
        html += '<th style="width:58px;background:#0F6E56">TOTAL</th>';
        html += '<th style="width:34px;background:#0F6E56">%</th>';
        html += '</tr>';

        // Fila 2: letras día semana
        html += '<tr><th></th>';
        diasInfo.forEach(function(di) {
          html += '<th style="background:#2a3754;font-weight:400;font-size:7px;color:#c8d3e5">' + di.diaSemana + '</th>';
        });
        html += '<th style="background:#0F6E56"></th><th style="background:#0F6E56"></th>';
        html += '</tr></thead><tbody>';

        // Filas de personas
        personasVisibles.forEach(function(p) {
          var pObj = self.pdfObjetivoProdPlan(pp, p);
          var pPlan = p.totalPlan || 0;
          var pPct = pObj > 0 ? Math.round(pPlan * 1000 / pObj) / 10 : 0;
          var porDia = p.porDia || {};
          var ausDia = p.ausenciasPorDia || {};

          html += '<tr><td style="font-weight:700;text-align:left;background:#f8fafc">' + self.pdfEsc(p.codigo) + '</td>';
          diasInfo.forEach(function(di) {
            var diaNum = di.dia;
            var esHoy = mesActual && diaNum === diaHoy;
            var aus = ausDia[String(diaNum)] || ausDia[diaNum];
            var val = porDia[String(diaNum)] || porDia[diaNum] || 0;
            var objDiaCelda = self.pdfObjDiaProdPlanDia(pp, p, diaNum);
            var cls = '', contenido = '·';
            if (aus) {
              cls = 'celda-ausencia';
              contenido = aus === 'vac' ? 'V' : aus === 'bl' ? 'B' : aus === 'fiesta' ? 'F' : aus === 'comp' ? 'C' : '?';
            } else if (val > 0 && objDiaCelda > 0 && fiable) {
              var pct = (val / objDiaCelda) * 100;
              if (pct > 100) cls = 'celda-excellent';
              else if (pct >= 98) cls = 'celda-good';
              else if (pct >= 94) cls = 'celda-warning';
              else cls = 'celda-critical';
              contenido = self.pdfFmtNumCorto(val);
            } else if (val > 0) {
              contenido = self.pdfFmtNumCorto(val);
            }
            if (esHoy) cls += ' celda-hoy';
            html += '<td class="' + cls + '">' + contenido + '</td>';
          });
          html += '<td style="font-weight:700;background:#eef1f7">' + self.pdfFmtNum(pPlan) + '</td>';
          html += '<td><span class="badge ' + self.pdfUmbralFiable(pPct, fiable) + '">' + self.pdfPctTxt(pPct, fiable) + '</span></td>';
          html += '</tr>';
        });

        // Fila TOTAL por día (sum de visibles). Sin colores celda-*: toda la fila es azul marino.
        html += '<tr class="fila-total-mat"><td style="text-align:left">TOTAL</td>';
        var granTotalMat = 0;
        diasInfo.forEach(function(di) {
          var sumDia = 0;
          personasVisibles.forEach(function(p) {
            var aus = (p.ausenciasPorDia || {})[String(di.dia)];
            if (!aus) {
              sumDia += (p.porDia && (p.porDia[String(di.dia)] || p.porDia[di.dia])) || 0;
            }
          });
          granTotalMat += sumDia;
          html += '<td>' + (sumDia > 0 ? self.pdfFmtNumCorto(sumDia) : '·') + '</td>';
        });
        html += '<td>' + self.pdfFmtNum(granTotalMat) + '</td>';
        var pctTot = 0;
        var sumObjMes = 0;
        personasVisibles.forEach(function(p) { sumObjMes += self.pdfObjetivoProdPlan(pp, p); });
        if (sumObjMes > 0) pctTot = Math.round(granTotalMat * 1000 / sumObjMes) / 10;
        html += '<td><span class="badge ' + self.pdfUmbralFiable(pctTot, fiable) + '" style="color:#1a2744">' + self.pdfPctTxt(pctTot, fiable) + '</span></td>';
        html += '</tr>';

        // Fila OBJ/DÍA
        html += '<tr class="fila-obj-mat"><td style="text-align:left">Obj/día</td>';
        diasInfo.forEach(function(di) {
          var sumObjDia = 0;
          personasVisibles.forEach(function(p) {
            sumObjDia += self.pdfObjDiaProdPlanDia(pp, p, di.dia);
          });
          var celdaObj = !fiable ? 'n/d' : (sumObjDia > 0 ? self.pdfFmtNumCorto(sumObjDia) : '·');
          html += '<td>' + celdaObj + '</td>';
        });
        html += '<td>' + (fiable ? self.pdfFmtNum(sumObjMes) : 'n/d') + '</td><td></td>';
        html += '</tr>';

        html += '</tbody></table>';

        html += '<div style="margin-top:8px;font-size:8px;display:block">'
          + '<span class="badge bg-azul">&gt;100%</span> &nbsp;'
          + '<span class="badge bg-verde">98-100%</span> &nbsp;'
          + '<span class="badge bg-ambar">94-97%</span> &nbsp;'
          + '<span class="badge bg-rojo">&lt;94%</span> &nbsp; &nbsp;'
          + '<span style="background:#fff8e1;color:#92400e;padding:2px 6px;border-radius:3px;font-weight:700">V</span> Vacaciones &nbsp;'
          + '<span style="background:#fff8e1;color:#92400e;padding:2px 6px;border-radius:3px;font-weight:700">B</span> Baja &nbsp;'
          + '<span style="background:#fff8e1;color:#92400e;padding:2px 6px;border-radius:3px;font-weight:700">F</span> Fiesta &nbsp;'
          + '<span style="background:#fff8e1;color:#92400e;padding:2px 6px;border-radius:3px;font-weight:700">C</span> Compensación &nbsp; &nbsp;'
          + '<span style="outline:2px solid #f59e0b;padding:2px 6px;border-radius:3px">HOY</span>'
          + '</div>';
      } else {
        html += '<div style="margin-top:20px;padding:20px;background:#fef3c7;border-radius:4px;color:#92400e;text-align:center;font-size:11px">'
          + 'No hay datos de matriz progresiva disponibles para ' + MESES[mes] + ' ' + anio + '.'
          + '</div>';
      }

      html += this.buildPie(anio, mes, dia);
      html += '</section>';
      return html;
    }
  }
};
</script>
